
export type ObjectFieldTypes = {
    [key: string]: { [key: string]: string | string[] }
};

export type OpTypes = {
    [key: string]: string | string[]
};

export type ScalarLocations = {
 scalars: string[],
 inputObjectFieldTypes: ObjectFieldTypes;
 outputObjectFieldTypes: ObjectFieldTypes;
 operationMap: OpTypes;
};

export const scalarLocations : ScalarLocations = {
  "inputObjectFieldTypes": {
    "BankAccountMoveDocumentInput": {
      "date": "Date"
    },
    "BankAccountMoveQueryArgs": {
      "where": "BankAccountMoveWhereConditions"
    },
    "BankAccountMoveWhereConditions": {
      "AND": "BankAccountMoveWhereConditions",
      "OR": "BankAccountMoveWhereConditions"
    },
    "BillingEntityQueryArgs": {
      "orderBy": "BillingEntityOrderByClause",
      "where": "BrandsWhereConditions"
    },
    "BillingPlanBudgetItemInput": {
      "billingPlanMonths": "BillingPlanMonthInput"
    },
    "BillingPlanCacheOverviewQueryArgs": {
      "date_from": "Date",
      "date_to": "Date",
      "orderBy": "BillingPlanCacheOrderByClause",
      "where": "BillingPlanCacheOverviewWhereConditions"
    },
    "BillingPlanCacheOverviewWhereConditions": {
      "AND": "BillingPlanCacheOverviewWhereConditions",
      "OR": "BillingPlanCacheOverviewWhereConditions"
    },
    "BillingPlanItemInput": {
      "date": "Date"
    },
    "BillingPlanMonthInput": {
      "date": "Date"
    },
    "BillingPlanOverviewQueryArgs": {
      "orderBy": "BillingPlanOrderByClause",
      "where": "BillingPlanOverviewWhereConditions"
    },
    "BillingPlanOverviewWhereConditions": {
      "AND": "BillingPlanOverviewWhereConditions",
      "OR": "BillingPlanOverviewWhereConditions"
    },
    "BrandCreditAccountsWhereConditions": {
      "AND": "BrandCreditAccountsWhereConditions",
      "OR": "BrandCreditAccountsWhereConditions"
    },
    "BrandQueryArgs": {
      "orderBy": "BrandOrderByClause",
      "where": "BrandsWhereConditions"
    },
    "BrandRevenueQueryArgs": {
      "from": "Date",
      "orderBy": "BrandRevenueOrderByClause",
      "to": "Date",
      "where": "BrandRevenueWhereConditions"
    },
    "BrandRevenueWhereConditions": {
      "AND": "BrandRevenueWhereConditions",
      "OR": "BrandRevenueWhereConditions"
    },
    "BrandsWhereConditions": {
      "AND": "BrandsWhereConditions",
      "OR": "BrandsWhereConditions"
    },
    "BudgetArgs": {
      "orderBy": "BudgetOrderByClause",
      "where": "BudgetWhereConditions"
    },
    "BudgetExportOptionsInput": {
      "date": "Date",
      "disclaimer": "BudgetPdfDisclaimerInput",
      "valid_until": "Date"
    },
    "BudgetItemPlannedExpenseInput": {
      "date": "Date"
    },
    "BudgetWhereConditions": {
      "AND": "BudgetWhereConditions",
      "OR": "BudgetWhereConditions"
    },
    "BulkEditTaskInput": {
      "add_task_positions": "TaskPositionInput",
      "deadline": "Date",
      "description": "TaskDescriptionInput",
      "from": "Date",
      "position_mapping": "PositionMappingInput",
      "to": "Date"
    },
    "CapacityAllocationRepetitionSettings": {
      "end": "Date"
    },
    "ClientQueryArgs": {
      "orderBy": "ClientOrderByClause",
      "where": "ClientsWhereConditions"
    },
    "ClientsWhereConditions": {
      "AND": "ClientsWhereConditions",
      "OR": "ClientsWhereConditions"
    },
    "CompleteCapacityAllocationUserInput": {
      "existingTimeTrackingItems": "UpdateTimeTrackingItemInput",
      "newTimeTrackingItem": "CreateTimeTrackingItemInput"
    },
    "ContractQueryArgs": {
      "orderBy": "ContractOrderByClause",
      "where": "ContractsWhereConditions"
    },
    "ContractorBasicQueryArgs": {
      "orderBy": "ContractorOrderByClause"
    },
    "ContractorQueryArgs": {
      "orderBy": "ContractorOrderByClause",
      "where": "ContractorsWhereConditions"
    },
    "ContractorsWhereConditions": {
      "AND": "ContractorsWhereConditions",
      "OR": "ContractorsWhereConditions"
    },
    "ContractsWhereConditions": {
      "AND": "ContractsWhereConditions",
      "OR": "ContractsWhereConditions"
    },
    "CreateBudgetItemPlannedExpensesInput": {
      "planned_expenses": "BudgetItemPlannedExpenseInput"
    },
    "CreateBudgetovacPositionsSetInput": {
      "positions_prices": "BudgetovacPositionPriceInput"
    },
    "CreateCapacityAllocationInput": {
      "attendees": "CapacityAllocationAttendee",
      "deadline": "Date",
      "deadline_time": "Time",
      "from_date": "Date",
      "from_time": "Time",
      "repetition_settings": "CapacityAllocationRepetitionSettings",
      "to_date": "Date",
      "to_time": "Time"
    },
    "CreateContractInput": {
      "valid_from": "Date",
      "valid_to": "Date"
    },
    "CreateCurrencyExchangeRateInput": {
      "valid_from": "Date",
      "valid_to": "Date"
    },
    "CreateExchangeRateSettingsInput": {
      "valid_from": "Date",
      "valid_to": "Date"
    },
    "CreateExpenseInput": {
      "date_of_supply": "Date",
      "due_date": "Date",
      "expense_items": "ExpenseItemInput",
      "expense_vat_items": "ExpenseVatItemInput",
      "files": "FileInput",
      "issue_date": "Date",
      "paid_at": "Date",
      "user_created_date": "Date"
    },
    "CreateInvoiceFromBillingPlanInput": {
      "issue_date": "Date"
    },
    "CreateOrderInput": {
      "date_of_order": "Date"
    },
    "CreateProjectFromTemplateInput": {
      "expected_end_date": "Date",
      "start_date": "Date"
    },
    "CreateProjectInput": {
      "expected_end_date": "Date",
      "start_date": "Date"
    },
    "CreateProjectTimeBillingInput": {
      "components": "TimeBillingComponentInput",
      "date_from": "Date",
      "date_to": "Date",
      "source_ids": "TimeBillingSourceInput",
      "user_rows": "TimeBillingUserRowInput"
    },
    "CreateRequestForInvoicingInput": {
      "date_of_supply": "Date",
      "due_date": "Date",
      "expense_budget_splits": "ExpenseBudgetSplitInput",
      "invoice_items": "InvoiceItemInput",
      "issue_date": "Date",
      "our_work_budget_splits": "OurWorkBudgetSplitInput",
      "prepayment_splits": "PrepaymentSplitInput",
      "timeMaterialsInvoiceData": "timeMaterialsInputData"
    },
    "CreateScopedTaskInput": {
      "deadline": "DateTime",
      "description": "TaskDescriptionInput"
    },
    "CreateTaskInput": {
      "deadline": "DateTime",
      "description": "TaskDescriptionInput",
      "from": "Date",
      "positions": "TaskPositionInput",
      "to": "Date"
    },
    "CreateTimeTrackingItemInput": {
      "specific_time_from": "Time",
      "specific_time_to": "Time",
      "tracked_for_date": "Date"
    },
    "CreditAccountQueryArgs": {
      "orderBy": "BrandCreditAccountOrderByClause",
      "where": "BrandCreditAccountsWhereConditions"
    },
    "DateRange": {
      "from": "Date",
      "to": "Date"
    },
    "DeleteCapacityAllocationForDayInput": {
      "date": "Date"
    },
    "ExpenseItemInput": {
      "planned_expense_usages": "PlannedExpenseUsageInput",
      "positions": "ExpenseItemPositionInput"
    },
    "ExpenseItemPositionInput": {
      "report_date": "Date"
    },
    "ExpenseItemsTimeBillingQueryArgs": {
      "orderBy": "ExpenseItemsTimeBillingOrderByClause",
      "where": "ExpenseItemsTimeBillingWhereConditions"
    },
    "ExpenseItemsTimeBillingWhereConditions": {
      "AND": "ExpenseItemsTimeBillingWhereConditions",
      "OR": "ExpenseItemsTimeBillingWhereConditions"
    },
    "ExpenseQueryArgs": {
      "orderBy": "ExpenseOrderByClause",
      "where": "ExpensesWhereConditions"
    },
    "ExpensesWhereConditions": {
      "AND": "ExpensesWhereConditions",
      "OR": "ExpensesWhereConditions"
    },
    "GlobalCreditAccountQueryArgs": {
      "orderBy": "GlobalCreditAccountOrderByClause",
      "where": "GlobalCreditAccountsWhereConditions"
    },
    "GlobalCreditAccountsWhereConditions": {
      "AND": "GlobalCreditAccountsWhereConditions",
      "OR": "GlobalCreditAccountsWhereConditions"
    },
    "InputAccountingAccount": {
      "budget_categories": "InputAccountingAccountBudgetCategory"
    },
    "InputUpdateWorkspaceAccountingAccountSettings": {
      "accounting_accounts": "InputAccountingAccount"
    },
    "InputUpdateWorkspaceAccountingCentreSettings": {
      "accounting_centres": "InputAccountingCentre"
    },
    "InputUpdateWorkspaceAccountingVatClassificationSettings": {
      "accounting_vat_classifications": "InputAccountingVatClassification"
    },
    "InputUpdateWorkspacePipedriveIntegration": {
      "settings": "WorkspacePipedriveIntegrationSettingInput"
    },
    "InputWorkspaceCompanySetting": {
      "companies": "WorkspaceCompanyInput"
    },
    "InputWorkspaceFinancialSetting": {
      "currencies": "CurrencyInput",
      "invoice_attachment_name_templates": "InvoiceAttachmentNameTemplatesInput",
      "vat_rates": "VatRateInput"
    },
    "InputWorkspacePlanningSetting": {
      "working_from": "Time",
      "working_to": "Time"
    },
    "InputWorkspaceTaskSettings": {
      "task_priorities": "WorkspaceTaskPriorityInput",
      "task_statuses": "WorkspaceTaskStatusInput"
    },
    "InputWorkspaceUserManagementSetting": {
      "teams": "InputWorkspaceTeamSetting"
    },
    "MoveCapacityAllocationItemInput": {
      "date": "Date"
    },
    "OIBudgetItemsTimeBillingQueryArgs": {
      "orderBy": "OIBudgetItemsTimeBillingOrderByClause",
      "where": "OIBudgetItemsTimeBillingWhereConditions"
    },
    "OIBudgetItemsTimeBillingWhereConditions": {
      "AND": "OIBudgetItemsTimeBillingWhereConditions",
      "OR": "OIBudgetItemsTimeBillingWhereConditions"
    },
    "OIProformaQueryArgs": {
      "orderBy": "OutgoingProformaInvoiceOrderByClause",
      "where": "OIProformaWhereConditions"
    },
    "OIProformaWhereConditions": {
      "AND": "OIProformaWhereConditions",
      "OR": "OIProformaWhereConditions"
    },
    "OIQueryArgs": {
      "orderBy": "OutgoingInvoiceOrderByClause",
      "where": "OIWhereConditions"
    },
    "OIWhereConditions": {
      "AND": "OIWhereConditions",
      "OR": "OIWhereConditions"
    },
    "OrderQueryArgs": {
      "orderBy": "OrderOrderByClause",
      "where": "OrdersWhereConditions"
    },
    "OrdersWhereConditions": {
      "AND": "OrdersWhereConditions",
      "OR": "OrdersWhereConditions"
    },
    "OtherDocumentQueryArgs": {
      "orderBy": "OtherDocumentOrderByClause",
      "where": "OtherDocumentsWhereConditions"
    },
    "OtherDocumentsWhereConditions": {
      "AND": "OtherDocumentsWhereConditions",
      "OR": "OtherDocumentsWhereConditions"
    },
    "OurWorkBudgetSplitInput": {
      "budget_positions": "BudgetPositionsInput"
    },
    "PlannedExpensesQueryArgs": {
      "orderBy": "PlannedExpensesOrderByClause",
      "where": "PlannedExpensesWhereConditions"
    },
    "PlannedExpensesWhereConditions": {
      "AND": "PlannedExpensesWhereConditions",
      "OR": "PlannedExpensesWhereConditions"
    },
    "PlanningDailyViewFilters": {
      "from": "Date",
      "to": "Date",
      "where": "PlanningDailyViewWhereCondition"
    },
    "PlanningDailyViewUnassignedTasksFilters": {
      "from": "Date",
      "to": "Date",
      "where": "PlanningViewUnassignedTasksWhereConditions"
    },
    "PlanningDailyViewWhereCondition": {
      "AND": "PlanningDailyViewWhereCondition",
      "OR": "PlanningDailyViewWhereCondition"
    },
    "PlanningRangeInput": {
      "valid_from": "Date",
      "valid_to": "Date",
      "weekly_capacities": "WeeklyCapacitiesInput"
    },
    "PlanningViewUnassignedTasksWhereConditions": {
      "AND": "PlanningViewUnassignedTasksWhereConditions",
      "OR": "PlanningViewUnassignedTasksWhereConditions"
    },
    "PreviewProjectTimeBillingInput": {
      "components": "TimeBillingComponentInput",
      "date_from": "Date",
      "date_to": "Date",
      "sources": "TimeBillingSourceInput",
      "user_rows": "TimeBillingUserRowPreviewInput"
    },
    "ProfitLossReportWhereConditions": {
      "AND": "ProfitLossReportWhereConditions",
      "OR": "ProfitLossReportWhereConditions"
    },
    "ProjectAllQueryArgs": {
      "where": "ProjectsAllWhereConditions"
    },
    "ProjectBillingsQueryArgs": {
      "date_from": "Date",
      "date_to": "Date",
      "orderBy": "ProjectBillingsOrderByClause",
      "where": "ProjectBillingsWhereConditions"
    },
    "ProjectBillingsWhereConditions": {
      "AND": "ProjectBillingsWhereConditions",
      "OR": "ProjectBillingsWhereConditions"
    },
    "ProjectLimitedQueryArgs": {
      "orderBy": "ProjectOrderByClause",
      "where": "ProjectsLimitedWhereConditions"
    },
    "ProjectQueryArgs": {
      "orderBy": "ProjectOrderByClause",
      "where": "ProjectsWhereConditions"
    },
    "ProjectRevenueQueryArgs": {
      "from": "Date",
      "orderBy": "ProjectRevenueOrderByClause",
      "to": "Date",
      "where": "ProjectRevenueWhereConditions"
    },
    "ProjectRevenueWhereConditions": {
      "AND": "ProjectRevenueWhereConditions",
      "OR": "ProjectRevenueWhereConditions"
    },
    "ProjectsAllWhereConditions": {
      "AND": "ProjectsAllWhereConditions",
      "OR": "ProjectsAllWhereConditions"
    },
    "ProjectsLimitedWhereConditions": {
      "AND": "ProjectsLimitedWhereConditions",
      "OR": "ProjectsLimitedWhereConditions"
    },
    "ProjectsWhereConditions": {
      "AND": "ProjectsWhereConditions",
      "OR": "ProjectsWhereConditions"
    },
    "QuotesArgs": {
      "orderBy": "BudgetOrderByClause",
      "where": "BudgetWhereConditions"
    },
    "RequestForInvoicingQueryArgs": {
      "orderBy": "RequestForInvoicingOrderByClause",
      "where": "RequestsForInvoicingWhereConditions"
    },
    "RequestsForInvoicingWhereConditions": {
      "AND": "RequestsForInvoicingWhereConditions",
      "OR": "RequestsForInvoicingWhereConditions"
    },
    "TaskQueryArgs": {
      "orderBy": "TaskOrderByClause",
      "where": "TaskWhereConditions"
    },
    "TaskWhereConditions": {
      "AND": "TaskWhereConditions",
      "OR": "TaskWhereConditions"
    },
    "TimeTrackingProjectReportQueryArgs": {
      "orderBy": "TimeTrackingProjectReportOrderByClause",
      "where": "TimeTrackingProjectReportsWhereConditions"
    },
    "TimeTrackingProjectReportsWhereConditions": {
      "AND": "TimeTrackingProjectReportsWhereConditions",
      "OR": "TimeTrackingProjectReportsWhereConditions"
    },
    "TimeTrackingReportsWhereConditions": {
      "AND": "TimeTrackingReportsWhereConditions",
      "OR": "TimeTrackingReportsWhereConditions"
    },
    "UpdateBillingPlanInput": {
      "items": "BillingPlanItemInput"
    },
    "UpdateBudgetItem": {
      "deadline": "Date"
    },
    "UpdateBudgetovacPositionsSetInput": {
      "positions_prices": "BudgetovacPositionPriceInput"
    },
    "UpdateCapacityAllocationForDayInput": {
      "attendees": "CapacityAllocationAttendee",
      "date": "Date",
      "deadline": "Date",
      "deadline_time": "Time",
      "from_time": "Time",
      "to_time": "Time"
    },
    "UpdateCapacityAllocationInput": {
      "attendees": "CapacityAllocationAttendee",
      "deadline": "Date",
      "deadline_time": "Time",
      "from_date": "Date",
      "from_time": "Time",
      "repetition_settings": "CapacityAllocationRepetitionSettings",
      "to_date": "Date",
      "to_time": "Time"
    },
    "UpdateCapacityAllocationItemInput": {
      "date": "Date",
      "from_time": "Time",
      "to_time": "Time"
    },
    "UpdateContractInput": {
      "valid_from": "Date",
      "valid_to": "Date"
    },
    "UpdateCurrencyExchangeRateInput": {
      "valid_from": "Date",
      "valid_to": "Date"
    },
    "UpdateExchangeRateSettingsInput": {
      "valid_from": "Date",
      "valid_to": "Date"
    },
    "UpdateExpenseInput": {
      "date_of_supply": "Date",
      "due_date": "Date",
      "expense_items": "ExpenseItemInput",
      "expense_vat_items": "ExpenseVatItemInput",
      "files": "FileInput",
      "issue_date": "Date",
      "paid_at": "Date",
      "user_created_date": "Date"
    },
    "UpdateFinanceSettingsInput": {
      "bankAccounts": "BankAccountSettingInput"
    },
    "UpdateOrderInput": {
      "date_of_order": "Date"
    },
    "UpdateOutgoingInvoiceInput": {
      "date_of_supply": "Date",
      "due_date": "Date",
      "expense_budget_splits": "ExpenseBudgetSplitInput",
      "invoice_items": "InvoiceItemInput",
      "issue_date": "Date",
      "our_work_budget_splits": "OurWorkBudgetSplitInput",
      "prepayment_splits": "PrepaymentSplitInput",
      "timeMaterialsInvoiceData": "timeMaterialsInputData"
    },
    "UpdateOutgoingProformaInvoiceInput": {
      "due_date": "Date",
      "expense_budget_splits": "ExpenseBudgetSplitInput",
      "invoice_items": "InvoiceItemInput",
      "issue_date": "Date",
      "our_work_budget_splits": "OurWorkBudgetSplitInput",
      "prepayment_splits": "PrepaymentSplitInput"
    },
    "UpdatePlanningSettings": {
      "planning_view_settings": "PlanningViewSettingInput"
    },
    "UpdateProjectBudgetInput": {
      "budget_valid_from": "Date",
      "expenses": "ExpenseBudgetItemInput",
      "ourWork": "OurWorkBudgetItemInput"
    },
    "UpdateProjectInput": {
      "expected_end_date": "Date",
      "start_date": "Date"
    },
    "UpdateProjectTimeBillingInput": {
      "components": "TimeBillingComponentInput",
      "source_ids": "TimeBillingSourceInput",
      "user_rows": "TimeBillingUserRowInput"
    },
    "UpdateRequestForInvoicingInput": {
      "date_of_supply": "Date",
      "due_date": "Date",
      "expense_budget_splits": "ExpenseBudgetSplitInput",
      "invoice_items": "InvoiceItemInput",
      "issue_date": "Date",
      "our_work_budget_splits": "OurWorkBudgetSplitInput",
      "prepayment_splits": "PrepaymentSplitInput",
      "timeMaterialsInvoiceData": "timeMaterialsInputData"
    },
    "UpdateScopedTaskInput": {
      "deadline": "DateTime",
      "description": "TaskDescriptionInput"
    },
    "UpdateTaskBoardSettingsInput": {
      "sort": "TaskBoardSortInput"
    },
    "UpdateTaskDescriptionInput": {
      "description": "TaskDescriptionInput"
    },
    "UpdateTaskInput": {
      "deadline": "DateTime",
      "description": "TaskDescriptionInput",
      "from": "Date",
      "position_mapping": "PositionMappingInput",
      "positions": "TaskPositionInput",
      "to": "Date"
    },
    "UpdateTimeTrackingBudgetItemInput": {
      "tracking_enabled_from": "Date",
      "tracking_enabled_to": "Date"
    },
    "UpdateTimeTrackingItemInput": {
      "specific_time_from": "Time",
      "specific_time_to": "Time",
      "tracked_for_date": "Date"
    },
    "UpdateTimeTrackingRatesForBrandInput": {
      "time_tracking_rates_per_work_type": "UpdateTimeTrackingRateInput"
    },
    "UpdateTimeTrackingRatesForProjectInput": {
      "time_tracking_rates_per_work_type": "UpdateTimeTrackingRateInput"
    },
    "UpdateTimeTrackingSettingsInput": {
      "our_work_budget_items": "UpdateTimeTrackingBudgetItemInput"
    },
    "UserProfileRateInput": {
      "valid_from": "Date",
      "valid_to": "Date"
    },
    "UserQueryArgs": {
      "orderBy": "UserOrderByClause",
      "where": "UsersWhereConditions"
    },
    "UsersWhereConditions": {
      "AND": "UsersWhereConditions",
      "OR": "UsersWhereConditions"
    },
    "UtilizationReportWhereConditions": {
      "AND": "UtilizationReportWhereConditions",
      "OR": "UtilizationReportWhereConditions"
    },
    "WhereConditions": {
      "AND": "WhereConditions",
      "HAS": "WhereConditionsRelation",
      "OR": "WhereConditions"
    },
    "WhereConditionsRelation": {
      "condition": "WhereConditions"
    },
    "WipQueryArgs": {
      "orderBy": "WipOrderByClause",
      "where": "WipsWhereConditions"
    },
    "WipsWhereConditions": {
      "AND": "WipsWhereConditions",
      "OR": "WipsWhereConditions"
    },
    "WorkspaceCompanyInput": {
      "bank_accounts": "WorkspaceCompanyBankAccountSettingInput",
      "pdfSettings": "WorkspaceInvoicePdfSettingsInput",
      "sequences": "WorkspaceSequenceSettingInput"
    },
    "lockProjectInput": {
      "orderBy": "WipOrderByClause",
      "where": "WipsWhereConditions"
    },
    "quoteInput": {
      "settings": "BudgetExportOptionsInput"
    },
    "timeMaterialsInputData": {
      "commission_data": "timeMaterialsCommissionInputData",
      "from": "Date",
      "to": "Date"
    },
    "timeMaterialsInvoiceWhereConditions": {
      "AND": "timeMaterialsInvoiceWhereConditions",
      "OR": "timeMaterialsInvoiceWhereConditions"
    },
    "timeMaterialsQueryArgs": {
      "where": "timeMaterialsInvoiceWhereConditions"
    },
    "updateBillingPlanBudgetInput": {
      "billingPlanBudgetItem": "BillingPlanBudgetItemInput"
    },
    "updateProjectBillingPlanBudgetInput": {
      "billingPlanBudgets": "updateBillingPlanBudgetInput"
    },
    "updateProjectBillingPlanSettingsInput": {
      "auto_send_thank_you_template": "ProjectBillingPlanEmailTemplateInput",
      "email_template": "ProjectBillingPlanEmailTemplateInput",
      "from": "Date",
      "to": "Date"
    },
    "updateWorkspaceNotifications": {
      "notifications": "WorkspaceNotificationInput"
    }
  },
  "outputObjectFieldTypes": {
    "AccountingAccount": {
      "budget_categories": "AccountingAccountBudgetCategory",
      "deleted_at": "DateTime"
    },
    "AccountingCentre": {
      "deleted_at": "DateTime"
    },
    "AccountingVatClassification": {
      "deleted_at": "DateTime",
      "vatRate": "VatRate"
    },
    "AssignableFile": {
      "created_at": "DateTime",
      "urls": "AssignableFileUrlPair"
    },
    "AttachedOutgoingProformaInvoicePivot": {
      "invoice": "OutgoingProformaInvoice"
    },
    "AttachedProofOfPaymentPivot": {
      "invoice": "OutgoingInvoice"
    },
    "Attendee": {
      "timeTrackingWorkType": "TimeTrackingWorkType",
      "user": "User"
    },
    "AutocompleteCompanyData": {
      "results": "AutocompleteCompanyDataResult"
    },
    "BankAccountMove": {
      "currency": "Currency",
      "date": "Date",
      "documents": "BankAccountMoveDocument"
    },
    "BankAccountMoveDocument": {
      "bankAccountMove": "BankAccountMove",
      "date": "Date",
      "document_currency": "Currency"
    },
    "BankAccountMovePaginator": {
      "data": "BankAccountMove",
      "paginatorInfo": "PaginatorInfo"
    },
    "BillingEntity": {
      "brands": "Brand",
      "country": "Country",
      "created_at": "DateTime",
      "defaultCurrency": "Currency",
      "updated_at": "DateTime",
      "workspaceBankAccount": "WorkspaceBankAccount",
      "workspaceCompany": "WorkspaceCompany"
    },
    "BillingEntityPaginator": {
      "data": "BillingEntity",
      "paginatorInfo": "PaginatorInfo"
    },
    "BillingPlanBudget": {
      "billingPlanBudgetItem": "BillingPlanBudgetItem",
      "category": "BillingPlanBudgetItemCategory"
    },
    "BillingPlanBudgetCache": {
      "brand": "Brand",
      "created_at": "DateTime",
      "date_of_supply": "Date",
      "due_date": "Date",
      "issue_date": "Date",
      "paid_at": "DateTime",
      "project": "Project",
      "updated_at": "DateTime"
    },
    "BillingPlanBudgetCachePaginator": {
      "data": "BillingPlanBudgetCache",
      "paginatorInfo": "PaginatorInfo"
    },
    "BillingPlanBudgetInvoice": {
      "date": "Date"
    },
    "BillingPlanBudgetItem": {
      "months": "BillingPlanMonth"
    },
    "BillingPlanByMonths": {
      "items": "BillingPlanItem"
    },
    "BillingPlanInvoice": {
      "brandCreditAccount": "BrandCreditAccount",
      "date": "Date",
      "outgoingInvoice": "OutgoingInvoice",
      "proformaInvoice": "OutgoingProformaInvoice"
    },
    "BillingPlanItem": {
      "date": "Date"
    },
    "BillingPlanMonth": {
      "billingPlanInvoice": "BillingPlanBudgetInvoice",
      "date": "Date"
    },
    "BillingPlanMonthStat": {
      "invoices": "BillingPlanInvoice",
      "items": "BillingPlanItem",
      "project": "Project"
    },
    "BillingPlanMonthStatPaginator": {
      "data": "BillingPlanMonthStat",
      "paginatorInfo": "PaginatorInfo"
    },
    "Brand": {
      "archived_at": "DateTime",
      "client": "Client",
      "contacts": "Contact",
      "contracts": "ContractPaginator",
      "created_at": "DateTime",
      "creditAccounts": "BrandCreditAccount",
      "defaultBillingEntity": "BillingEntity",
      "externalLinks": "ExternalLink",
      "image": "AssignableFile",
      "otherDocuments": "OtherDocumentPaginator",
      "otherResponsiblePersons": "User",
      "pipedriveCustomFieldValues": "PipedriveCustomFieldValue",
      "projects": "Project",
      "responsiblePerson": "User",
      "stats": "BrandStats",
      "timeTrackingRates": "TimeTrackingRate",
      "updated_at": "DateTime",
      "users": "User"
    },
    "BrandCreditAccount": {
      "brand": "Brand",
      "created_at": "DateTime",
      "creditAccount": "CreditAccount",
      "credits": "BrandCreditAccountCreditStats",
      "debits": "BrandCreditAccountDebitStats",
      "expenseBudgetCategories": "ExpenseBudgetCategory",
      "ourWorkBudgetCategories": "OurWorkBudgetCategory",
      "stats": "BrandCreditAccountStats",
      "team": "Team",
      "updated_at": "DateTime"
    },
    "BrandCreditAccountCreditStats": {
      "date": "Date",
      "originatesBrandCreditAccount": "BrandCreditAccount",
      "outgoingInvoice": "OutgoingInvoice"
    },
    "BrandCreditAccountDebitStats": {
      "brandCreditAccount": "BrandCreditAccount",
      "expenseBudgetItem": "ExpenseBudgetItem",
      "ourWorkBudgetItem": "OurWorkBudgetItem",
      "performed_at": "Date"
    },
    "BrandCreditAccountPaginator": {
      "data": "BrandCreditAccount",
      "paginatorInfo": "PaginatorInfo"
    },
    "BrandPaginator": {
      "data": "Brand",
      "paginatorInfo": "PaginatorInfo"
    },
    "BrandRevenue": {
      "paginatorInfo": "PaginatorInfo",
      "result": "BrandWithRevenueResult"
    },
    "BrandRevenueSummary": {
      "brand_profit_share": "BrandRevenueShare",
      "brand_revenue_share": "BrandRevenueShare",
      "client_revenue_share": "BrandRevenueShare",
      "expense_revenue_for_date_range": "ExpenseRevenueByCategory",
      "profit_top_clients": "TopClient",
      "revenue_top_clients": "TopClient"
    },
    "BrandSimple": {
      "archived_at": "DateTime",
      "defaultBillingEntity": "BillingEntity",
      "deleted_at": "DateTime"
    },
    "BrandWithRevenue": {
      "expenses_billings_for_date_range": "ProjectRevenueBillingsByExpenseCategory",
      "expenses_profit_for_date_range": "ProjectRevenueProfitByExpenseCategory",
      "image": "AssignableFile",
      "ourWork": "OurWorkBudgetItemWithRevenue"
    },
    "BrandWithRevenueResult": {
      "brands": "BrandWithRevenue",
      "expensesStructured": "ExpenseStructuredBudgetItemWithRevenue",
      "expenses_billings_for_date_range": "ProjectRevenueBillingsByExpenseCategory",
      "expenses_profit_for_date_range": "ProjectRevenueProfitByExpenseCategory",
      "image": "AssignableFile",
      "ourWork": "OurWorkBudgetItemWithRevenue"
    },
    "Budget": {
      "assignment_date": "Date",
      "brand": "Brand",
      "created_at": "DateTime",
      "currency": "Currency",
      "project": "Project",
      "quotes": "Quote",
      "temporaryBrand": "TemporaryBrand",
      "temporaryProject": "TemporaryProject",
      "updated_at": "DateTime"
    },
    "BudgetGroup": {
      "budgets": "Budget"
    },
    "BudgetItemPlannedExpense": {
      "contractor": "Contractor",
      "created_at": "DateTime",
      "date": "Date",
      "updated_at": "DateTime",
      "usedExpenses": "BudgetItemPlannedExpenseUsed"
    },
    "BudgetItemPlannedExpenseUsed": {
      "created_at": "DateTime",
      "expenseItem": "ExpenseItem",
      "plannedExpense": "BudgetItemPlannedExpense",
      "updated_at": "DateTime"
    },
    "BudgetPaginator": {
      "data": "BudgetGroup",
      "paginatorInfo": "PaginatorInfo"
    },
    "BudgetPdfSettings": {
      "date": "Date",
      "disclaimer": "BudgetPdfDisclaimer",
      "valid_until": "Date"
    },
    "BudgetovacBrandPositionsSet": {
      "brand": "Brand",
      "budgetovacPositionSets": "BudgetovacPositionsSet"
    },
    "BudgetovacPosition": {
      "created_at": "DateTime",
      "updated_at": "DateTime"
    },
    "BudgetovacPositionsSet": {
      "created_at": "DateTime",
      "positions_prices": "BudgetovacPositionPrice",
      "updated_at": "DateTime"
    },
    "CapacityAllocation": {
      "attendees": "Attendee",
      "calendarParticipants": "CalendarEventParticipant",
      "capacityAllocationItems": "CapacityAllocationItem",
      "createdBy": "User",
      "created_at": "DateTime",
      "deadline": "Date",
      "deadline_time": "Time",
      "from_date": "Date",
      "from_time": "Time",
      "repetition_settings": "RepetitionSettings",
      "task": "Task",
      "teams": "TeamAttendee",
      "timeOffType": "TimeOffType",
      "to_date": "Date",
      "to_time": "Time"
    },
    "CapacityAllocationItem": {
      "capacityAllocation": "CapacityAllocation",
      "createdBy": "User",
      "date": "Date",
      "from_time": "Time",
      "seriesSummary": "CapacityAllocationSeriesSummary",
      "stats": "CapacityAllocationItemStats",
      "teams": "TeamAttendee",
      "timeOffType": "TimeOffType",
      "timeTrackingWorkType": "TimeTrackingWorkType",
      "to_time": "Time",
      "user": "User",
      "userItems": "CapacityAllocationItem",
      "userStats": "CapacityAllocationUserItemStats"
    },
    "CapacityAllocationItemStats": {
      "deadline": "Date",
      "deadline_time": "Time",
      "tracking_enabled_from": "Date",
      "tracking_enabled_to": "Date"
    },
    "CapacityAllocationSeriesSummary": {
      "futureCompletedPerUser": "CapacityAllocationUserCompletedCount"
    },
    "Client": {
      "billingEntities": "BillingEntity",
      "brands": "Brand",
      "contacts": "Contact",
      "contracts": "ContractPaginator",
      "created_at": "DateTime",
      "currencyExchangeRates": "CurrencyExchangeRate",
      "currencyExchangeRatesStructured": "CurrencyExchangeRateStructured",
      "image": "AssignableFile",
      "otherDocuments": "OtherDocumentPaginator",
      "otherResponsiblePersons": "User",
      "responsiblePerson": "User",
      "updated_at": "DateTime",
      "workspaceCompany": "WorkspaceCompany"
    },
    "ClientPaginator": {
      "data": "Client",
      "paginatorInfo": "PaginatorInfo"
    },
    "ClientSimple": {
      "brands": "BrandSimple",
      "created_at": "DateTime",
      "deleted_at": "DateTime",
      "updated_at": "DateTime"
    },
    "CompanyData": {
      "bankAccounts": "CompanyBankAccount",
      "country": "Country"
    },
    "Contact": {
      "created_at": "DateTime",
      "image": "AssignableFile",
      "pipedriveCustomFieldValues": "PipedriveCustomFieldValue",
      "updated_at": "DateTime"
    },
    "Contract": {
      "brands": "Brand",
      "clients": "Client",
      "contractors": "Contractor",
      "created_at": "DateTime",
      "files": "AssignableFile",
      "pdfFiles": "AssignableFile",
      "projects": "Project",
      "updated_at": "DateTime",
      "urls": "MediaUrlList",
      "valid_from": "Date",
      "valid_to": "Date"
    },
    "ContractPaginator": {
      "data": "Contract",
      "paginatorInfo": "PaginatorInfo"
    },
    "Contractor": {
      "contracts": "ContractPaginator",
      "contractsNonPaginated": "Contract",
      "country": "Country",
      "created_at": "DateTime",
      "defaultAccountingAccount": "AccountingAccount",
      "otherDocuments": "OtherDocumentPaginator",
      "updated_at": "DateTime"
    },
    "ContractorPaginator": {
      "data": "Contractor",
      "paginatorInfo": "PaginatorInfo"
    },
    "ContractorsBasic": {
      "contractorsList": "ContractorBasic"
    },
    "Country": {
      "created_at": "DateTime",
      "updated_at": "DateTime"
    },
    "CreditAccount": {
      "created_at": "DateTime",
      "team": "Team",
      "updated_at": "DateTime"
    },
    "CurrencyExchangeRate": {
      "created_at": "DateTime",
      "currency": "Currency",
      "updated_at": "DateTime",
      "valid_from": "Date",
      "valid_to": "Date"
    },
    "CurrencyExchangeRateStructured": {
      "currency": "Currency",
      "exchangeRates": "CurrencyExchangeRate"
    },
    "DateIntegerDataPoint": {
      "date": "Date"
    },
    "DocumentExport": {
      "created_at": "DateTime",
      "exported_at": "DateTime",
      "updated_at": "DateTime"
    },
    "Expense": {
      "accountMoves": "BankAccountMoveDocument",
      "contract": "Contract",
      "contractor": "Contractor",
      "country": "Country",
      "currency": "Currency",
      "date_of_supply": "Date",
      "defaultAccountingAccount": "AccountingAccount",
      "documentExports": "DocumentExport",
      "due_date": "Date",
      "emailData": "ExpenseEmailData",
      "expenseItems": "ExpenseItem",
      "expenseItemsStructured": "StructuredExpenseItemsItem",
      "expenseVatItems": "ExpenseVatItem",
      "expense_documents": "AssignableFile",
      "issue_date": "Date",
      "lockedDocument": "LockDocument",
      "modelLock": "ModelLock",
      "paid_at": "Date",
      "payment_type": "PaymentType",
      "projectTimeBilling": "ProjectTimeBilling",
      "projects": "Project",
      "relatedExpenses": "Expense",
      "stats": "ExpenseStats",
      "updated_at": "DateTime",
      "user_created_date": "Date"
    },
    "ExpenseBudgetCategory": {
      "created_at": "DateTime",
      "deleted_at": "DateTime",
      "updated_at": "DateTime"
    },
    "ExpenseBudgetItem": {
      "category": "ExpenseBudgetCategory",
      "completed_at": "DateTime",
      "created_at": "DateTime",
      "creditAccount": "CreditAccount",
      "deleted_at": "DateTime",
      "expenseStats": "ExpenseBudgetItemExpenseStats",
      "globalPrepaymentStats": "ExpenseBudgetItemGlobalPrepaymentStats",
      "invoiceStats": "ExpenseBudgetItemInvoiceStats",
      "outgoingProformaInvoiceStats": "OurWorkBudgetItemProformaStats",
      "plannedExpenses": "BudgetItemPlannedExpense",
      "prepaymentStats": "ExpenseBudgetItemPrepaymentStats",
      "project": "Project",
      "requested_for_deletion_at": "DateTime",
      "stats": "ExpenseBudgetItemStats",
      "updated_at": "DateTime"
    },
    "ExpenseBudgetItemExpenseStats": {
      "contractor": "Contractor",
      "date": "Date",
      "expense": "Expense"
    },
    "ExpenseBudgetItemGlobalPrepaymentStats": {
      "date": "Date",
      "expenseBudgetItem": "ExpenseBudgetItem",
      "globalCreditAccount": "GlobalCreditAccount"
    },
    "ExpenseBudgetItemInvoiceStats": {
      "expenseBudgetItem": "ExpenseBudgetItem",
      "outgoingInvoice": "OutgoingInvoice"
    },
    "ExpenseBudgetItemPrepaymentStats": {
      "brandCreditAccount": "BrandCreditAccount",
      "date": "Date",
      "expenseBudgetItem": "ExpenseBudgetItem"
    },
    "ExpenseBudgetItemSimple": {
      "category": "ExpenseBudgetCategory",
      "completed_at": "DateTime",
      "created_at": "DateTime",
      "deleted_at": "DateTime",
      "project": "ProjectSimple",
      "stats": "ExpenseBudgetItemStatsSimple",
      "updated_at": "DateTime"
    },
    "ExpenseBudgetItemWithRevenue": {
      "expenseBudgetItem": "ExpenseBudgetItem"
    },
    "ExpenseEmailData": {
      "received_at": "Date"
    },
    "ExpenseItem": {
      "accountingAccount": "AccountingAccount",
      "approvals": "ExpenseItemApproval",
      "budgetItem": [
        "ExpenseBudgetItem",
        "OurWorkBudgetItem"
      ],
      "description": "ExpenseItemDesciption",
      "expense": "Expense",
      "globalCreditAccount": "GlobalCreditAccount",
      "positions": "ExpenseItemPosition",
      "timeBillings": "ProjectTimeBilling",
      "vatRate": "VatRate"
    },
    "ExpenseItemApproval": {
      "created_at": "DateTime",
      "user": "User"
    },
    "ExpenseItemDesciption": {
      "deleted_at": "DateTime"
    },
    "ExpenseItemForProject": {
      "created_at": "Date"
    },
    "ExpenseItemPaginator": {
      "data": "ExpenseItem",
      "paginatorInfo": "PaginatorInfo"
    },
    "ExpenseItemPosition": {
      "report_date": "Date",
      "task": "Task"
    },
    "ExpensePaginator": {
      "data": "Expense",
      "paginatorInfo": "PaginatorInfo"
    },
    "ExpenseRevenueByCategory": {
      "category": "ExpenseBudgetCategory"
    },
    "ExpenseStructuredBudgetItem": {
      "budgetItems": "ExpenseBudgetItem"
    },
    "ExpenseStructuredBudgetItemWithRevenue": {
      "budgetItems": "ExpenseBudgetItemWithRevenue",
      "expenseBudgetCategory": "ExpenseBudgetCategory"
    },
    "FinanceSettings": {
      "bankAccounts": "BankAccountSetting"
    },
    "GetTimeTrackingItemsPaginator": {
      "data": "TimeTrackingReport",
      "paginatorInfo": "PaginatorInfo"
    },
    "GlobalCreditAccount": {
      "created_at": "DateTime",
      "creditAccount": "CreditAccount",
      "credits": "GlobalCreditAccountCreditStats",
      "debits": "GlobalCreditAccountDebitStats",
      "stats": "GlobalCreditAccountStats",
      "updated_at": "DateTime"
    },
    "GlobalCreditAccountCreditStats": {
      "date": "Date",
      "expense": "Expense",
      "originatesGlobalCreditAccount": "GlobalCreditAccount"
    },
    "GlobalCreditAccountDebitStats": {
      "expenseBudgetItem": "ExpenseBudgetItem",
      "originatesGlobalCreditAccount": "GlobalCreditAccount",
      "performed_at": "Date"
    },
    "GlobalCreditAccountPaginator": {
      "data": "GlobalCreditAccount",
      "paginatorInfo": "PaginatorInfo"
    },
    "InvoiceEmailData": {
      "attachments": "InvoiceEmailDataAttachment"
    },
    "LockDocument": {
      "locked_to": "DateTime",
      "user": "User"
    },
    "MapQuestAddress": {
      "country": "Country"
    },
    "McpToken": {
      "created_at": "DateTime",
      "updated_at": "DateTime"
    },
    "ModelLock": {
      "deletedByUser": "User",
      "deleted_at": "DateTime",
      "lockedByUser": "User",
      "locked_at": "DateTime"
    },
    "Mutation": {
      "UpdateCapacityAllocationForDay": "CapacityAllocation",
      "UpdateWorkspaceNotifications": "WorkspaceNotification",
      "addDocumentsToAccountMove": "BankAccountMove",
      "addManualAccountMove": "BankAccountMove",
      "addRowToWeekTimeReport": "WeeklyTimeReportRow",
      "addTaskAssignee": "Task",
      "addTaskFiles": "Task",
      "addTaskLink": "TaskLink",
      "archiveBrand": "Brand",
      "archiveProject": "Project",
      "archiveProjectsBulk": "BulkActionResponse",
      "budgetInternalApprove": "Budget",
      "bulkArchiveBrand": "BulkActionResponse",
      "bulkDeleteBrand": "BulkActionResponse",
      "bulkDeleteExpenses": "BulkActionResponse",
      "bulkDeleteTimeTrackingItems": "BulkActionResponse",
      "bulkLockModel": "BulkActionResponse",
      "bulkStar": "BulkActionResponse",
      "bulkStarProjects": "BulkActionResponse",
      "bulkUnlockModel": "BulkActionResponse",
      "bulkUnstar": "BulkActionResponse",
      "bulkUnstarProjects": "BulkActionResponse",
      "bulkUpdateProjects": "BulkActionResponse",
      "changeBudgetAssignedAt": "Budget",
      "changeRateCardOnProject": "Project",
      "cloneExpense": "Expense",
      "closeWip": "WorkInProgressProjectStat",
      "closeWipBulk": "BulkActionResponse",
      "completeCapacityAllocationItem": "CapacityAllocationItem",
      "completeExpenseBudgetItem": "ExpenseBudgetItem",
      "completeExpenseBudgetItemBulk": "ExpenseBudgetItem",
      "connectToMcp": "ConnectToMcpPayload",
      "copyCapacityAllocationItem": "CapacityAllocationItem",
      "createAssignableFile": "AssignableFile",
      "createBillingEntity": "BillingEntity",
      "createBillingPlan": "BillingPlanByMonths",
      "createBrand": "Brand",
      "createBrandCreditAccount": "BrandCreditAccount",
      "createBudgetItemPlannedExpenses": "BudgetItemPlannedExpense",
      "createBudgetItemPlannedExpensesBulk": "BudgetItemPlannedExpense",
      "createBudgetovacPosition": "BudgetovacPosition",
      "createBudgetovacPositionsSet": "BudgetovacPositionsSet",
      "createCapacityAllocation": "CapacityAllocation",
      "createClient": "Client",
      "createContact": "Contact",
      "createContract": "Contract",
      "createContractor": "Contractor",
      "createCurrencyExchangeRate": "CurrencyExchangeRate",
      "createEmailTemplate": "EmailTemplate",
      "createExchangeRateForWorkspace": "CurrencyExchangeRate",
      "createExpense": "Expense",
      "createExpenseBudgetItem": "ExpenseBudgetItem",
      "createExpenseItemDescription": "ExpenseItemDesciption",
      "createExternalLink": "ExternalLink",
      "createFilterTemplate": "FilterTemplate",
      "createGlobalCreditAccount": "GlobalCreditAccount",
      "createInvoiceFromBillingPlan": "RequestForInvoicing",
      "createOrder": "Order",
      "createOtherDocument": "OtherDocument",
      "createOurWorkBudgetItem": "OurWorkBudgetItemOverview",
      "createOutgoingInvoice": "OutgoingInvoice",
      "createOutgoingProformaInvoice": "OutgoingProformaInvoice",
      "createProject": "Project",
      "createProjectCategory": "ProjectCategory",
      "createProjectFromPipedrive": "Project",
      "createProjectFromTemplate": "Project",
      "createProjectTimeBilling": "ProjectTimeBilling",
      "createProjectTimeBreakdown": "ProjectTimeBreakdown",
      "createQuote": "Quote",
      "createRequestForInvoicing": "RequestForInvoicing",
      "createScopedTask": "Task",
      "createScopedUser": "User",
      "createSequence": "Sequence",
      "createTag": "Tag",
      "createTask": "Task",
      "createTaskComment": "TaskComment",
      "createTaskTemplateGroup": "TaskTemplateGroup",
      "createTimeTrackingItem": "TimeTrackingItem",
      "createTimeTrackingWorkType": "TimeTrackingWorkType",
      "createUpdateExpenseContractor": "Expense",
      "createUser": "User",
      "createVatRate": "VatRate",
      "createWorkspaceSmtpSettings": "WorkspaceSmtpSettings",
      "deleteAssignableFile": "BooleanResult",
      "deleteBillingEntity": "BillingEntity",
      "deleteBrand": "Brand",
      "deleteBrandCreditAccount": "BrandCreditAccount",
      "deleteBudgetovacPosition": "BudgetovacPosition",
      "deleteBudgetovacPositionsSet": "BudgetovacPositionsSet",
      "deleteCapacityAllocation": "CapacityAllocation",
      "deleteCapacityAllocationForDay": "CapacityAllocation",
      "deleteCapacityAllocationItem": "CapacityAllocationItem",
      "deleteClient": "Client",
      "deleteContact": "Contact",
      "deleteContract": "Contract",
      "deleteContractor": "Contractor",
      "deleteContractorsBulk": "BulkActionResponse",
      "deleteExchangeRateForWorkspace": "CurrencyExchangeRate",
      "deleteExpense": "Expense",
      "deleteOrder": "Order",
      "deleteOtherDocument": "OtherDocument",
      "deleteProject": "Project",
      "deleteProjectCategory": "ProjectCategory",
      "deleteProjectsBulk": "BulkActionResponse",
      "deleteRequestForInvoicing": "RequestForInvoicing",
      "deleteRequestsForInvoicingBulk": "BulkActionResponse",
      "deleteTask": "Task",
      "deleteTaskComment": "TaskComment",
      "deleteTaskLink": "TaskLink",
      "deleteTimeTrackingItem": "TimeTrackingItem",
      "deleteTimeTrackingWorkType": "TimeTrackingWorkType",
      "deleteUser": "User",
      "disableTwoFactorAuthentication": "User",
      "disconnectFromMcp": "ConnectToMcpPayload",
      "duplicateProject": "Project",
      "duplicateTask": "Task",
      "editTaskWatchers": "Task",
      "excludeBankAccountMove": "BankAccountMove",
      "findAddressForExpense": "MapQuestAddress",
      "finishProject": "Project",
      "invoiceProject": "RequestForInvoicing",
      "invoiceProjectByCurrentMonthBillingPlan": "RequestForInvoicing",
      "invoiceProjectsBulk": "RequestForInvoicing",
      "lastSeen": "Task",
      "lockBillingPlanForProject": "Project",
      "lockDocument": "LockDocument",
      "lockModel": "ModelLock",
      "lockProjectTimeBilling": "ProjectTimeBilling",
      "lockWip": "WorkInProgressProjectStat",
      "lockWipBulk": "BulkActionResponse",
      "manualApproveQuote": "Quote",
      "markExpenseAsPaid": "Expense",
      "markExpenseAsPaidBulk": "BulkActionResponse",
      "markExpenseAsUnpaid": "Expense",
      "markNotificationAsRead": "Notification",
      "markNotificationAsUnread": "Notification",
      "markOutgoingInvoiceAsPaid": "OutgoingInvoice",
      "markOutgoingInvoiceAsPaidBulk": "BulkActionResponse",
      "markOutgoingInvoiceAsUnpaid": "OutgoingInvoice",
      "markOutgoingProformaInvoiceAsPaid": "OutgoingProformaInvoice",
      "markOutgoingProformaInvoiceAsUnpaid": "OutgoingProformaInvoice",
      "moveCapacityAllocationItem": "CapacityAllocationItem",
      "moveTaskOnBoard": "Task",
      "moveTimeTrackingItemsToTask": "BulkActionResponse",
      "moveTimeTrackingItemsToWorkType": "BulkActionResponse",
      "openWip": "WorkInProgressProjectStat",
      "openWipBulk": "BulkActionResponse",
      "pinProject": "Project",
      "pinProjectsBulk": "BulkActionResponse",
      "previewQuote": "Quote",
      "proformaInvoiceProject": "RequestForInvoicing",
      "redistributeProjectCredit": "Project",
      "removeRowFromWeekTimeReport": "WeeklyTimeReportRow",
      "removeTaskFiles": "Task",
      "reopenCapacityAllocationItem": "CapacityAllocationItem",
      "reopenExpenseBudgetItem": "ExpenseBudgetItem",
      "reopenProject": "Project",
      "reorderCapacityAllocationItems": "CapacityAllocationItem",
      "resetBillingPlanNotifications": "Project",
      "saveQuote": "Quote",
      "scheduleUserActivation": "User",
      "scheduleUserArchival": "User",
      "sendQuote": "Quote",
      "sendTestEmail": "SmtpTestResult",
      "setActiveBudgetovacPositionsSet": "BudgetovacPositionsSet",
      "setUserProfilePlanningRanges": "UserProfile",
      "setUserProfileRates": "UserProfile",
      "star": "Star",
      "starProject": "Star",
      "stopTimerForCapacityAllocationItem": "CapacityAllocationItem",
      "submitProgress": "SubmitProgressResult",
      "submitProgressBulk": "OurWorkBudgetItem",
      "submitRequestForInvoicing": "RequestForInvoicing",
      "submitRequestsForInvoicingBulk": "BulkActionResponse",
      "testSmtpConnection": "SmtpTestResult",
      "toggleTaskCommentReaction": "TaskCommentReaction",
      "unarchiveBrand": "Brand",
      "unarchiveProject": "Project",
      "unarchiveProjectsBulk": "BulkActionResponse",
      "unlockDocument": "LockDocument",
      "unlockProjectTimeBilling": "ProjectTimeBilling",
      "unlockTimeTrackingItems": "BulkActionResponse",
      "unlockWip": "WorkInProgressProjectStat",
      "unlockWipBulk": "BulkActionResponse",
      "unpinProject": "Project",
      "unpinProjectsBulk": "BulkActionResponse",
      "updateBillingEntity": "BillingEntity",
      "updateBillingPlan": "BillingPlanByMonths",
      "updateBrand": "Brand",
      "updateBrandCreditAccount": "BrandCreditAccount",
      "updateBudgetovacPosition": "BudgetovacPosition",
      "updateBudgetovacPositionsSet": "BudgetovacPositionsSet",
      "updateCapacityAllocation": "CapacityAllocation",
      "updateCapacityAllocationItem": "CapacityAllocationItem",
      "updateClient": "Client",
      "updateCompanySettings": "CompanySettings",
      "updateContact": "Contact",
      "updateContract": "Contract",
      "updateContractor": "Contractor",
      "updateCurrencyExchangeRate": "CurrencyExchangeRate",
      "updateEmailTemplate": "EmailTemplate",
      "updateExchangeRateForWorkspace": "CurrencyExchangeRate",
      "updateExpense": "Expense",
      "updateExpenseBudgetItemNote": "ExpenseBudgetItem",
      "updateExpenseItemDescription": "ExpenseItemDesciption",
      "updateExternalLink": "ExternalLink",
      "updateFinanceSettings": "FinanceSettings",
      "updateGlobalCreditAccount": "GlobalCreditAccount",
      "updateNotificationSetting": "NotificationSetting",
      "updateNotificationSettings": "NotificationSettings",
      "updateOrder": "Order",
      "updateOtherDocument": "OtherDocument",
      "updateOurWorkBudgetItemNote": "OurWorkBudgetItem",
      "updateOurWorkBudgetItems": "OurWorkBudgetItem",
      "updateOutgoingInvoice": "OutgoingInvoice",
      "updateOutgoingInvoiceNumber": "OutgoingInvoice",
      "updateOutgoingProformaInvoice": "OutgoingProformaInvoice",
      "updatePassword": "User",
      "updatePaymentSettings": "NotificationSettings",
      "updatePlanningSettings": "WorkspaceSettings",
      "updateProject": "Project",
      "updateProjectBillingPlanBudget": "BillingPlanBudget",
      "updateProjectBillingPlanSettings": "Project",
      "updateProjectBudget": "Project",
      "updateProjectCategory": "ProjectCategory",
      "updateProjectSettings": "ProjectSettings",
      "updateProjectStage": "Project",
      "updateProjectTimeBilling": "ProjectTimeBilling",
      "updateProjectTimeBreakdown": "ProjectTimeBreakdown",
      "updateRequestForInvoicing": "RequestForInvoicing",
      "updateScopedTask": "Task",
      "updateSequence": "Sequence",
      "updateTag": "Tag",
      "updateTask": "Task",
      "updateTaskAssignees": "Task",
      "updateTaskBillable": "Task",
      "updateTaskBoardSettings": "TaskBoardSettings",
      "updateTaskComment": "TaskComment",
      "updateTaskCurrentAssignee": "Task",
      "updateTaskDeadline": "Task",
      "updateTaskDescription": "Task",
      "updateTaskDuration": "Task",
      "updateTaskPriority": "Task",
      "updateTaskStatus": "Task",
      "updateTaskTemplateGroup": "TaskTemplateGroup",
      "updateTimeTrackingItem": "TimeTrackingItem",
      "updateTimeTrackingItemsBillable": "BulkActionResponse",
      "updateTimeTrackingRatesForBrand": "Brand",
      "updateTimeTrackingRatesForProject": "Project",
      "updateTimeTrackingSettingsForProject": "Project",
      "updateTimeTrackingWorkType": "TimeTrackingWorkType",
      "updateUser": "User",
      "updateUserPassword": "User",
      "updateVatRate": "VatRate",
      "updateWorkspaceAccountingAccountSettings": "WorkspaceAccountingAccountSettings",
      "updateWorkspaceAccountingCentreSettings": "WorkspaceAccountingCentreSettings",
      "updateWorkspaceAccountingVatClassificationSettings": "WorkspaceAccountingVatClassificationSettings",
      "updateWorkspaceAutoExpenseEmail": "WorkspaceAutoExpenseEmailSettings",
      "updateWorkspaceCompanies": "WorkspaceCompanySetting",
      "updateWorkspaceFinancialSettings": "WorkspaceFinancialSetting",
      "updateWorkspacePipedriveIntegration": "WorkspacePipedriveIntegration",
      "updateWorkspacePlanningSettings": "WorkspacePlanningSettings",
      "updateWorkspaceProjectSettings": "WorkspaceProjectSettings",
      "updateWorkspaceSmtpSettings": "WorkspaceSmtpSettings",
      "updateWorkspaceTaskSettings": "WorkspaceTaskSettings",
      "updateWorkspaceUserManagementSettings": "WorkspaceUserManagementSetting"
    },
    "Notification": {
      "created_at": "DateTime",
      "read_at": "DateTime"
    },
    "NotificationPaginator": {
      "data": "Notification",
      "paginatorInfo": "PaginatorInfo"
    },
    "NotificationPerTask": {
      "notifications": "Notification",
      "task": "Task"
    },
    "OCRExpenseData": {
      "date_of_supply": "Date",
      "due_date": "Date",
      "expense_items": "OCRExpenseItemData",
      "issue_date": "Date"
    },
    "OIBudgetItemForTimeBilling": {
      "budgetItem": [
        "ExpenseBudgetItem",
        "OurWorkBudgetItem"
      ],
      "outgoingInvoice": "OutgoingInvoice"
    },
    "OIBudgetItemsForTimeBillingPaginator": {
      "data": "OIBudgetItemForTimeBilling",
      "paginatorInfo": "PaginatorInfo"
    },
    "Order": {
      "brand": "Brand",
      "created_at": "DateTime",
      "date_of_order": "Date",
      "files": "AssignableFile",
      "outgoingInvoices": "OutgoingInvoice",
      "pdfFiles": "AssignableFile",
      "projects": "Project",
      "updated_at": "DateTime",
      "urls": "MediaUrlList"
    },
    "OrderPaginator": {
      "data": "Order",
      "paginatorInfo": "PaginatorInfo"
    },
    "OtherDocument": {
      "brands": "Brand",
      "clients": "Client",
      "contractors": "Contractor",
      "created_at": "DateTime",
      "files": "AssignableFile",
      "pdfFiles": "AssignableFile",
      "projects": "Project",
      "updated_at": "DateTime",
      "urls": "MediaUrlList"
    },
    "OtherDocumentPaginator": {
      "data": "OtherDocument",
      "paginatorInfo": "PaginatorInfo"
    },
    "OtherPeopleTracked": {
      "user": "User"
    },
    "OurWorkBudgetCategory": {
      "created_at": "DateTime",
      "deleted_at": "DateTime",
      "updated_at": "DateTime"
    },
    "OurWorkBudgetItem": {
      "availableTimeTrackingWorkTypes": "TimeTrackingRate",
      "budget_positions": "BudgetPosition",
      "category": "OurWorkBudgetCategory",
      "completed_at": "DateTime",
      "created_at": "DateTime",
      "creditAccount": "CreditAccount",
      "currentWorkInProgressItemStat": "WorkInProgressItemStat",
      "deadline": "Date",
      "deleted_at": "DateTime",
      "expenseStats": "OurWorkBudgetItemExpenseStats",
      "invoiceStats": "OurWorkBudgetItemInvoiceStats",
      "lastWorkInProgressItemStat": "WorkInProgressItemStat",
      "outgoingProformaInvoiceStats": "OurWorkBudgetItemProformaStats",
      "plannedExpenses": "BudgetItemPlannedExpense",
      "prepaymentStats": "OurWorkBudgetItemPrepaymentStats",
      "project": "Project",
      "requested_for_deletion_at": "DateTime",
      "stats": "OurWorkBudgetItemStats",
      "tasks": "Task",
      "timeTrackingSettings": "TimeTrackingBudgetItem",
      "updated_at": "DateTime"
    },
    "OurWorkBudgetItemExpenseStats": {
      "expense": "Expense",
      "position": "TimeTrackingWorkType",
      "report_date": "Date",
      "task": "Task"
    },
    "OurWorkBudgetItemForPlanovac": {
      "completed_at": "DateTime",
      "created_at": "DateTime",
      "deleted_at": "DateTime",
      "timeTrackingSettings": "TimeTrackingBudgetItemForPlanovac",
      "updated_at": "DateTime"
    },
    "OurWorkBudgetItemInvoiceStats": {
      "ourWorkBudgetItem": "OurWorkBudgetItem",
      "outgoingInvoice": "OutgoingInvoice"
    },
    "OurWorkBudgetItemLimited": {
      "availablepositions": "TimeTrackingWorkType"
    },
    "OurWorkBudgetItemOverview": {
      "budget_positions": "BudgetPosition",
      "category": "OurWorkBudgetCategory",
      "completed_at": "DateTime",
      "created_at": "DateTime",
      "creditAccount": "CreditAccount",
      "currentWorkInProgressItemStat": "WorkInProgressItemStat",
      "deadline": "Date",
      "deleted_at": "DateTime",
      "expenseStats": "OurWorkBudgetItemExpenseStats",
      "invoiceStats": "OurWorkBudgetItemInvoiceStats",
      "lastWorkInProgressItemStat": "WorkInProgressItemStat",
      "plannedExpenses": "BudgetItemPlannedExpense",
      "prepaymentStats": "OurWorkBudgetItemPrepaymentStats",
      "project": "Project",
      "requested_for_deletion_at": "DateTime",
      "stats": "OurWorkBudgetItemStats",
      "tasks": "Task",
      "timeTrackingSettings": "TimeTrackingBudgetItem",
      "updated_at": "DateTime"
    },
    "OurWorkBudgetItemPrepaymentStats": {
      "brandCreditAccount": "BrandCreditAccount",
      "date": "Date",
      "ourWorkBudgetItem": "OurWorkBudgetItem"
    },
    "OurWorkBudgetItemProformaStats": {
      "date": "Date"
    },
    "OurWorkBudgetItemSimple": {
      "category": "OurWorkBudgetCategory",
      "completed_at": "DateTime",
      "created_at": "DateTime",
      "deleted_at": "DateTime",
      "project": "ProjectSimple",
      "stats": "OurWorkBudgetItemStats",
      "tasks": "TaskSimple",
      "timeTrackingSettings": "TimeTrackingBudgetItem",
      "updated_at": "DateTime"
    },
    "OurWorkBudgetItemWithRevenue": {
      "ourWorkBudgetItem": "OurWorkBudgetItem"
    },
    "OurWorkOverviewBudgetItem": {
      "budgetItems": "OurWorkBudgetItemOverview"
    },
    "OurWorkStructuredBudgetItem": {
      "budgetItems": "OurWorkBudgetItem"
    },
    "OutgoingInvoice": {
      "accountMoves": "BankAccountMoveDocument",
      "billingEntity": "BillingEntity",
      "brands": "Brand",
      "budget_positions": "BudgetPosition",
      "client": "Client",
      "contact": "Contact",
      "created_at": "DateTime",
      "currency": "Currency",
      "date_of_supply": "Date",
      "documentExports": "DocumentExport",
      "due_date": "Date",
      "emailLogs": "OutgoingInvoiceEmailLog",
      "expenseBudgetSplits": "OutgoingInvoiceExpenseBudgetSplitItem",
      "filesToAttach": "AssignableFile",
      "invoiceItems": "OutgoingInvoiceItem",
      "invoicePaymentMethod": "InvoicePaymentMethod",
      "invoicePdf": "MediaUrlList",
      "invoiceProofOfPayments": "AttachedProofOfPaymentPivot",
      "issue_date": "Date",
      "modelLock": "ModelLock",
      "orders": "Order",
      "ourWorkBudgetSplits": "OutgoingInvoiceOurWorkBudgetSplitItem",
      "owner": "User",
      "paid_at": "Date",
      "prepaymentSplits": "OutgoingInvoicePrepaymentSplitItem",
      "proformaInvoicesPivot": "AttachedOutgoingProformaInvoicePivot",
      "projectTimeBilling": "ProjectTimeBilling",
      "projects": "Project",
      "relatesToOutgoingProformaInvoice": "OutgoingProformaInvoice",
      "request_for_invoicing_created_date": "Date",
      "request_for_invoicing_submit_date": "Date",
      "sequence": "Sequence",
      "stats": "OutgoingInvoiceStats",
      "summaryInvoicesForProofOfPayment": "OutgoingInvoice",
      "teams": "Team",
      "timeMaterialsInvoiceData": "TimeMaterialsInvoiceData",
      "updated_at": "DateTime"
    },
    "OutgoingInvoiceEmailLog": {
      "created_at": "DateTime",
      "recipientLog": "RecipientLog",
      "recipients": "Recipient",
      "sent_at": "DateTime"
    },
    "OutgoingInvoiceExpenseBudgetSplitItem": {
      "created_at": "DateTime",
      "updated_at": "DateTime"
    },
    "OutgoingInvoiceOurWorkBudgetSplitItem": {
      "created_at": "DateTime",
      "updated_at": "DateTime"
    },
    "OutgoingInvoicePaginator": {
      "data": "OutgoingInvoice",
      "paginatorInfo": "PaginatorInfo"
    },
    "OutgoingInvoicePrepaymentSplitItem": {
      "brandCreditAccount": "BrandCreditAccount",
      "created_at": "DateTime",
      "updated_at": "DateTime"
    },
    "OutgoingProformaInvoice": {
      "accountMoves": "BankAccountMoveDocument",
      "billingEntity": "BillingEntity",
      "brands": "Brand",
      "budget_positions": "BudgetPosition",
      "client": "Client",
      "contact": "Contact",
      "created_at": "DateTime",
      "currency": "Currency",
      "documentExports": "DocumentExport",
      "due_date": "Date",
      "emailLogs": "OutgoingInvoiceEmailLog",
      "expenseBudgetSplits": "RequestForInvoicingExpenseBudgetSplitItem",
      "filesToAttach": "AssignableFile",
      "invoiceItems": "OutgoingInvoiceItem",
      "invoicePaymentMethod": "InvoicePaymentMethod",
      "invoicePdf": "MediaUrlList",
      "issue_date": "Date",
      "modelLock": "ModelLock",
      "ourWorkBudgetSplits": "RequestForInvoicingOurWorkBudgetSplitItem",
      "owner": "User",
      "paid_at": "Date",
      "prepaymentSplits": "RequestForInvoicingPrepaymentSplitItem",
      "projects": "Project",
      "proofOfPayments": "OutgoingInvoice",
      "request_for_invoicing_created_date": "Date",
      "request_for_invoicing_submit_date": "Date",
      "stats": "OutgoingProformaInvoiceStats",
      "summaryInvoices": "OutgoingInvoice",
      "teams": "Team",
      "updated_at": "DateTime"
    },
    "OutgoingProformaInvoicePaginator": {
      "data": "OutgoingProformaInvoice",
      "paginatorInfo": "PaginatorInfo"
    },
    "PipedriveCustomFieldValue": {
      "customField": "PipedriveCustomField"
    },
    "PlannedExpensesProject": {
      "budget_items": "PlannedExpensesBudgetItem",
      "project": "Project"
    },
    "PlannedExpensesProjectPaginator": {
      "data": "PlannedExpensesProject",
      "paginatorInfo": "PaginatorInfo"
    },
    "PlanningDailyViewCapacityAllocationUserItem": {
      "item": "CapacityAllocationItem",
      "stats": "CapacityAllocationUserItemStats",
      "timeTrackingWorkType": "TimeTrackingWorkType",
      "user": "User"
    },
    "PlanningDailyViewPaginator": {
      "data": "PlanningDailyViewUserByDay",
      "last_updated_at": "DateTime",
      "paginatorInfo": "PaginatorInfo"
    },
    "PlanningDailyViewTimeOff": {
      "createdBy": "User",
      "created_at": "DateTime",
      "from_date": "Date",
      "from_time": "Time",
      "repetition_settings": "RepetitionSettings",
      "teams": "TeamAttendee",
      "timeOffType": "TimeOffType",
      "to_date": "Date",
      "to_time": "Time"
    },
    "PlanningDailyViewTimeOffItem": {
      "assignees": "TimeOffAssignee",
      "date": "Date",
      "from_time": "Time",
      "timeOff": "PlanningDailyViewTimeOff",
      "timeOffType": "TimeOffType",
      "to_time": "Time"
    },
    "PlanningDailyViewUnassignedTasksPerDay": {
      "afterDeadline": "Task",
      "date": "Date",
      "other": "Task"
    },
    "PlanningDailyViewUserByDay": {
      "items": "PlanningDailyViewUserDay",
      "user": "User"
    },
    "PlanningDailyViewUserDay": {
      "date": "Date",
      "items": "CapacityAllocationItem"
    },
    "PositionSpent": {
      "timeTrackingWorkType": "TimeTrackingWorkType"
    },
    "ProfitLossReport": {
      "columns": "ProfitLossReportColumn"
    },
    "ProfitLossReportGroup": {
      "columns": "ProfitLossReportColumn",
      "items": "ProfitLossReport"
    },
    "ProfitLossReportGroupPaginator": {
      "data": "ProfitLossReportGroup",
      "paginatorInfo": "PaginatorInfo"
    },
    "ProfitLossReportPaginator": {
      "data": "ProfitLossReport",
      "paginatorInfo": "PaginatorInfo"
    },
    "ProfitLossReportSummary": {
      "data": "ProfitLossReportColumn"
    },
    "Project": {
      "archivedBy": "User",
      "archived_at": "DateTime",
      "availableTimeTrackingWorkTypes": "TimeTrackingWorkType",
      "billingPlanByMonths": "BillingPlanByMonths",
      "billingPlanItems": "BillingPlanItem",
      "billingPlanNotifications": "BillingPlanNotifications",
      "billingPlanSetting": "ProjectBillingPlanSetting",
      "brand": "Brand",
      "budgetovacBudget": "ProjectBudgetPivot",
      "budgetovacBudgets": "Budget",
      "categories": "ProjectCategory",
      "contact": "Contact",
      "contracts": "ContractPaginator",
      "created_at": "DateTime",
      "currentMonthBillingPlanStats": "BillingPlanStats",
      "currentWorkInProgressProjectStat": "WorkInProgressProjectStat",
      "expected_end_date": "Date",
      "expenses": "ExpenseBudgetItem",
      "expensesStructured": "ExpenseStructuredBudgetItem",
      "expensesWithoutOther": "ExpenseBudgetItem",
      "expensesWithoutOtherStructured": "ExpenseStructuredBudgetItem",
      "externalLinks": "ExternalLink",
      "finishedBy": "User",
      "finished_at": "DateTime",
      "invoiceStats": "ProjectInvoiceStat",
      "lastInvoice": "ProjectInvoiceStat",
      "lastWorkInProgressProjectStat": "WorkInProgressProjectStat",
      "lowestPossibleDateForStartDateChange": "DateTime",
      "orders": "OrderPaginator",
      "ordersSimpleMap": "OrderSimple",
      "otherDocuments": "OtherDocumentPaginator",
      "otherProjectManagers": "User",
      "ourWork": "OurWorkBudgetItem",
      "ourWorkOverview": "OurWorkOverviewBudgetItem",
      "ourWorkStructured": "OurWorkStructuredBudgetItem",
      "pipedriveCustomFieldValues": "PipedriveCustomFieldValue",
      "prepaymentStats": "ProjectPrepaymentStat",
      "proformaInvoices": "OutgoingProformaInvoice",
      "projectManager": "User",
      "project_stage": "ProjectStage",
      "scopes": "UserScope",
      "start_date": "Date",
      "stats": "ProjectStats",
      "statsCached": "ProjectStats",
      "team": "Team",
      "timeTrackingRates": "TimeTrackingRate",
      "updated_at": "DateTime",
      "users": "User"
    },
    "ProjectBilling": {
      "billing_plan_setting": "ProjectBillingPlanSetting",
      "invoiced_expense_categories": "ProjectBillingExpenseCategoryAmount",
      "items": "ProjectBillingItem",
      "planned_expense_categories": "ProjectBillingExpenseCategoryAmount",
      "project": "Project"
    },
    "ProjectBillingItem": {
      "billingPlanBudgetCache": "BillingPlanBudgetCache",
      "brandCreditAccount": "BrandCreditAccount",
      "created_at": "DateTime",
      "date_of_supply": "Date",
      "due_date": "Date",
      "invoiced_expense_categories": "ProjectBillingExpenseCategoryAmount",
      "issue_date": "Date",
      "outgoingInvoice": "OutgoingInvoice",
      "outgoingProformaInvoice": "OutgoingProformaInvoice",
      "paid_at": "DateTime",
      "planned_expense_categories": "ProjectBillingExpenseCategoryAmount",
      "requestForInvoicing": "RequestForInvoicing",
      "updated_at": "DateTime"
    },
    "ProjectBillingPaginator": {
      "data": "ProjectBilling",
      "paginatorInfo": "PaginatorInfo"
    },
    "ProjectBillingPlanSetting": {
      "auto_send_thank_you_template": "ProjectBillingPlanEmailTemplate",
      "email_template": "ProjectBillingPlanEmailTemplate",
      "from": "Date",
      "lockedByUser": "User",
      "locked_at": "DateTime",
      "to": "Date"
    },
    "ProjectBillingsSummary": {
      "total_invoiced_expense_categories": "ProjectBillingExpenseCategoryAmount",
      "total_planned_expense_categories": "ProjectBillingExpenseCategoryAmount"
    },
    "ProjectDatesForBudgetChange": {
      "defaultDateForBudgetChange": "Date",
      "lowestPossibleDateForBudgetChange": "Date"
    },
    "ProjectFinishSummary": {
      "incomplete_expense_budget_items": "ExpenseBudgetItem",
      "incomplete_our_work_budget_items": "OurWorkBudgetItem",
      "overinvoiced_expense_budget_items": "ExpenseBudgetItem",
      "overinvoiced_our_work_budget_items": "OurWorkBudgetItem",
      "underinvoiced_expense_budget_items": "ExpenseBudgetItem",
      "underinvoiced_our_work_budget_items": "OurWorkBudgetItem"
    },
    "ProjectForExpense": {
      "brand": "BrandSimple",
      "expenses": "ExpenseBudgetItemSimple",
      "finished_at": "DateTime",
      "ourWorkBudgetItems": "OurWorkBudgetItemSimple",
      "team": "Team"
    },
    "ProjectForPlanovac": {
      "archived_at": "DateTime",
      "availableTimeTrackingWorkTypes": "TimeTrackingWorkType",
      "brand": "BrandSimple",
      "created_at": "DateTime",
      "deleted_at": "DateTime",
      "finished_at": "DateTime",
      "ourWork": "OurWorkBudgetItem",
      "updated_at": "DateTime"
    },
    "ProjectForPlanovacPaginator": {
      "data": "ProjectForPlanovac",
      "paginatorInfo": "PaginatorInfo"
    },
    "ProjectForTask": {
      "availableTimeTrackingWorkTypes": "TimeTrackingWorkType",
      "expected_end_date": "Date",
      "ourWork": "OurWorkBudgetItemSimple",
      "start_date": "Date"
    },
    "ProjectGraph": {
      "spentBudgetData": "DateIntegerDataPoint",
      "totalBudgetData": "DateIntegerDataPoint",
      "wipData": "DateIntegerDataPoint"
    },
    "ProjectInvoiceStat": {
      "outgoingInvoice": "OutgoingInvoice",
      "outgoing_invoice_date": "Date"
    },
    "ProjectLimited": {
      "ourWork": "OurWorkBudgetItemLimited"
    },
    "ProjectLimitedPaginator": {
      "data": "ProjectLimited",
      "paginatorInfo": "PaginatorInfo"
    },
    "ProjectPaginator": {
      "data": "Project",
      "paginatorInfo": "PaginatorInfo"
    },
    "ProjectPrepaymentStat": {
      "brandCreditAccount": "BrandCreditAccount",
      "date": "Date",
      "expenseBudgetItem": "ExpenseBudgetItem",
      "ourWorkBudgetItem": "OurWorkBudgetItem"
    },
    "ProjectRevenue": {
      "paginatorInfo": "PaginatorInfo",
      "projects": "ProjectWithRevenueItem"
    },
    "ProjectRevenueSummary": {
      "brand_profit_share": "BrandRevenueShare",
      "brand_revenue_share": "BrandRevenueShare",
      "client_revenue_share": "BrandRevenueShare",
      "expense_revenue_for_date_range": "ExpenseRevenueByCategory",
      "profit_top_projects": "TopProject",
      "revenue_top_projects": "TopProject"
    },
    "ProjectSimple": {
      "archived_at": "DateTime",
      "availableTimeTrackingWorkTypes": "TimeTrackingWorkType",
      "brand": "BrandSimple",
      "created_at": "DateTime",
      "deleted_at": "DateTime",
      "finished_at": "DateTime",
      "updated_at": "DateTime"
    },
    "ProjectSimplePaginator": {
      "data": "ProjectSimple",
      "paginatorInfo": "PaginatorInfo"
    },
    "ProjectStats": {
      "expenses": "ProjectExpenseStats",
      "ourWork": "ProjectOurWorkStats"
    },
    "ProjectTimeBilling": {
      "components": "ProjectTimeBillingComponent",
      "createdByUser": "User",
      "created_at": "DateTime",
      "date_from": "Date",
      "date_to": "Date",
      "distributions": "ProjectTimeBillingDistribution",
      "lockedByUser": "User",
      "locked_at": "DateTime",
      "project": "Project",
      "sources": "ProjectTimeBillingSource",
      "updated_at": "DateTime",
      "userRows": "ProjectTimeBillingUserRow"
    },
    "ProjectTimeBillingComponent": {
      "created_at": "DateTime",
      "source": "ProjectTimeBillingSource",
      "updated_at": "DateTime"
    },
    "ProjectTimeBillingComputed": {
      "components": "ProjectTimeBillingComponentPreview",
      "date_from": "Date",
      "date_to": "Date",
      "distributions": "ProjectTimeBillingDistributionPreview",
      "sources": "ProjectTimeBillingSourcePreview",
      "userRows": "ProjectTimeBillingUserRowPreview"
    },
    "ProjectTimeBillingDistribution": {
      "created_at": "DateTime",
      "projectTimeBilling": "ProjectTimeBilling",
      "timeTrackingItem": "TimeTrackingItem",
      "updated_at": "DateTime"
    },
    "ProjectTimeBillingDistributionPreview": {
      "timeTrackingItem": "TimeTrackingItem"
    },
    "ProjectTimeBillingPaginator": {
      "data": "ProjectTimeBilling",
      "paginatorInfo": "PaginatorInfo"
    },
    "ProjectTimeBillingSource": {
      "budgetItem": [
        "ExpenseBudgetItem",
        "OurWorkBudgetItem"
      ],
      "components": "ProjectTimeBillingComponent",
      "created_at": "DateTime",
      "expense": "Expense",
      "expenseItem": "ExpenseItem",
      "outgoingInvoice": "OutgoingInvoice"
    },
    "ProjectTimeBillingSourcePreview": {
      "budgetItem": [
        "ExpenseBudgetItem",
        "OurWorkBudgetItem"
      ],
      "expense": "Expense",
      "expenseItem": "ExpenseItem",
      "outgoingInvoice": "OutgoingInvoice"
    },
    "ProjectTimeBillingUserRow": {
      "created_at": "DateTime",
      "position": "TimeTrackingWorkType",
      "team": "Team",
      "updated_at": "DateTime",
      "user": "User"
    },
    "ProjectTimeBillingUserRowPreview": {
      "position": "TimeTrackingWorkType",
      "team": "Team",
      "user": "User"
    },
    "ProjectTimeBreakdown": {
      "dateFrom": "Date",
      "dateTo": "Date",
      "ourWorkBudgetItem": "OurWorkBudgetItem",
      "project": "Project"
    },
    "ProjectTimeBreakdownDetail": {
      "date_from": "Date",
      "date_to": "Date"
    },
    "ProjectTimeBreakdownResponse": {
      "time_breakdown": "ProjectTimeBreakdownDetail"
    },
    "ProjectWithRevenue": {
      "archived_at": "DateTime",
      "brand": "Brand",
      "expensesStructured": "ExpenseStructuredBudgetItemWithRevenue",
      "expenses_billings_for_date_range": "ProjectRevenueBillingsByExpenseCategory",
      "expenses_profit_for_date_range": "ProjectRevenueProfitByExpenseCategory",
      "finished_at": "DateTime",
      "ourWork": "OurWorkBudgetItemWithRevenue",
      "projectManager": "User"
    },
    "ProjectWithRevenueItem": {
      "archived_at": "DateTime",
      "brand": "Brand",
      "expenses_billings_for_date_range": "ProjectRevenueBillingsByExpenseCategory",
      "expenses_profit_for_date_range": "ProjectRevenueProfitByExpenseCategory",
      "finished_at": "DateTime",
      "ourWork": "OurWorkBudgetItemWithRevenue",
      "projectManager": "User"
    },
    "Query": {
      "EmailTemplates": "EmailTemplate",
      "GetQuote": "Quote",
      "GetQuoteEmailData": "QuoteEmailData",
      "GetUsersAllocatedTime": "UserAllocatedTime",
      "GetUsersAllocationConflicts": "UserAllocationConflicts",
      "WorkspaceNotifications": "WorkspaceNotification",
      "accountingAccountsSimpleMap": "AccountingAccount",
      "accountingCentres": "AccountingCentre",
      "availableTaskPositionsHoursByOurWorkBudget": "TaskPositionHour",
      "bankAccountConverter": "BankAccountConverter",
      "bankAccountMoves": "BankAccountMovePaginator",
      "bankAccounts": "BankAccount",
      "banksQuery": "Bank",
      "billingEntities": "BillingEntityPaginator",
      "billingPlanBudget": "BillingPlanBudget",
      "billingPlanCacheOverview": "BillingPlanBudgetCachePaginator",
      "billingPlanCacheOverviewSummary": "BillingPlanCacheOverviewSummary",
      "billingPlanOverview": "BillingPlanMonthStatPaginator",
      "billingPlanOverviewSummary": "BillingPlanOverviewSummary",
      "brand": "Brand",
      "brandCreditAccount": "BrandCreditAccount",
      "brandCreditAccounts": "BrandCreditAccountPaginator",
      "brandCreditAccountsSummary": "BrandCreditAccountsSummary",
      "brandRevenue": "BrandRevenue",
      "brandRevenueSummary": "BrandRevenueSummary",
      "brands": "BrandPaginator",
      "brandsForClient": "Brand",
      "brandsSimpleMap": "BrandSimple",
      "brandsSummary": "BrandsSummary",
      "budgetItemPlannedExpenses": "BudgetItemPlannedExpense",
      "budgetovacPosition": "BudgetovacPosition",
      "budgetovacPositions": "BudgetovacPosition",
      "budgetovacPositionsSet": "BudgetovacPositionsSet",
      "budgetovacPositionsSets": "BudgetovacBrandPositionsSet",
      "budgets": "BudgetPaginator",
      "budgetsForProject": "BudgetGroup",
      "bulkConvertAmountFromWorkspaceCurrencyUsingUserExchangeRates": "ConvertedAmountWithIdentifier",
      "bulkConvertAmountToWorkspaceCurrencyUsingUserExchangeRates": "ConvertedAmountWithIdentifier",
      "capacityAllocationDetail": "CapacityAllocation",
      "capacityAllocationItemDetailQuery": "CapacityAllocationItem",
      "capacityAllocationItemList": "CapacityAllocationItem",
      "capacityAllocationItemTimeTrackingItems": "TimeTrackingItem",
      "client": "Client",
      "clientExchangeRatesForBudgetovac": "CurrencyExchangeRate",
      "clients": "ClientPaginator",
      "clientsSimpleMap": "ClientSimple",
      "commentHistory": "TaskComment",
      "companySettings": "CompanySettings",
      "contacts": "Contact",
      "contract": "Contract",
      "contractor": "Contractor",
      "contractors": "ContractorPaginator",
      "contractorsBasic": "ContractorsBasic",
      "contractorsSimpleMap": "ContractorSimple",
      "contractorsSummary": "ContractorsSummary",
      "contracts": "ContractPaginator",
      "contractsSimpleMap": "ContractSimple",
      "contractsSummary": "ContractsSummary",
      "convertAmountToWorkspaceCurrencyUsingExchangeRate": "ConvertedAmount",
      "countrySimpleMap": "CountrySimple",
      "createDataForProjectTimeBilling": "ProjectTimeBillingComputed",
      "creditAccount": "CreditAccount",
      "currencies": "Currency",
      "currency": "Currency",
      "defaultCurrencies": "DefaultCurrency",
      "expense": "Expense",
      "expenseBudgetCategories": "ExpenseBudgetCategory",
      "expenseBudgetItem": "ExpenseBudgetItem",
      "expenseBudgetItemsByItemCode": "ExpenseBudgetItemSimple",
      "expenseBudgetItemsSimpleMap": "ExpenseBudgetItemSimple",
      "expenseBudgetItemsWithStatus": "ExpenseBudgetItemWithStatus",
      "expenseItemDescriptions": "ExpenseItemDesciption",
      "expenseItemsForProject": "ExpenseItemForProject",
      "expenseItemsForTimeBilling": "ExpenseItemPaginator",
      "expenseItemsForTimeBillingSummary": "TimeBillingSummary",
      "expenses": "ExpensePaginator",
      "expensesSummary": "ExpensesSummary",
      "externalLinks": "ExternalLink",
      "fetchOCRExpenseData": "OCRExpenseData",
      "filterTemplates": "FilterTemplate",
      "financeSettings": "FinanceSettings",
      "fondContractorsSimpleMap": "FondContractorSimple",
      "generateExpensePaymentOrder": "ExpensePaymentOrderResponse",
      "getAutocompleteForCompanyData": "AutocompleteCompanyData",
      "getAvailableProjectsForBulkMovingTimeTrackingItems": "ProjectSimple",
      "getAvailableWorkTypesForBulkMovingTimeTrackingItems": "TimeTrackingWorkType",
      "getBudgetQuotes": "QuotesPaginator",
      "getCompanyDataByRegistrationNo": "CompanyData",
      "getInvoiceEmailData": "InvoiceEmailData",
      "getLatestExpenseInternalNumberPerType": "LatestExpenseInternalNumberPerType",
      "getModelLock": "ModelLock",
      "getNewInvoiceNumber": "InvoiceSequenceData",
      "getPermissions": "PermissionList",
      "getPipedriveStages": "PipedriveStage",
      "getProformaInvoiceEmailData": "InvoiceEmailData",
      "getProjectCanBeFinishedSummary": "ProjectFinishSummary",
      "getTags": "Tag",
      "getTimeTrackingItems": "GetTimeTrackingItemsPaginator",
      "getTimeTrackingItemsSummary": "GetTimeTrackingItemsSummary",
      "getUnmatchedWorkTypesForTaskMove": "TaskMoveUnmatchedData",
      "globalCreditAccount": "GlobalCreditAccount",
      "globalCreditAccounts": "GlobalCreditAccountPaginator",
      "invoicePaymentMethods": "InvoicePaymentMethod",
      "lowestDateWithOpenProgress": "Date",
      "me": "User",
      "notificationSettings": "NotificationSetting",
      "notificationWorkspaceSettings": "NotificationSettings",
      "notifications": "NotificationPaginator",
      "oiBudgetItemsForTimeBilling": "OIBudgetItemsForTimeBillingPaginator",
      "oiBudgetItemsForTimeBillingSummary": "TimeBillingSummary",
      "order": "Order",
      "orders": "OrderPaginator",
      "ordersSummary": "OrdersSummary",
      "ordersWithPdf": "Order",
      "otherDocument": "OtherDocument",
      "otherDocuments": "OtherDocumentPaginator",
      "otherDocumentsSummary": "OtherDocumentsSummary",
      "otherDocumentsWithPdf": "OtherDocument",
      "ourWorkBudgetCategories": "OurWorkBudgetCategory",
      "ourWorkBudgetItem": "OurWorkBudgetItem",
      "ourWorkBudgetItemsByItemCode": "OurWorkBudgetItemSimple",
      "ourWorkBudgetItemsSimpleMap": "OurWorkBudgetItemSimple",
      "outgoingInvoice": "OutgoingInvoice",
      "outgoingInvoices": "OutgoingInvoicePaginator",
      "outgoingInvoicesSummary": "OutgoingInvoicesSummary",
      "outgoingProformaInvoice": "OutgoingProformaInvoice",
      "outgoingProformaInvoices": "OutgoingProformaInvoicePaginator",
      "outgoingProformaInvoicesSummary": "OutgoingProformaInvoicesSummary",
      "paymentSettings": "PaymentSettings",
      "paymentTypes": "PaymentType",
      "plannedExpensesOverview": "PlannedExpensesProjectPaginator",
      "plannedExpensesOverviewSummary": "PlannedExpensesSummary",
      "planningDailyViewPeople": "PlanningDailyViewPaginator",
      "planningDailyViewUnassignedTasks": "PlanningDailyViewUnassignedTasksPerDay",
      "prepareTaskDataForBulkActions": "TaskBulkActionsData",
      "previewProjectTimeBilling": "ProjectTimeBillingComputed",
      "profitLossReport": "ProfitLossReportGroupPaginator",
      "profitLossReportSummary": "ProfitLossReportSummary",
      "project": "Project",
      "projectBilling": "ProjectBilling",
      "projectBillings": "ProjectBillingPaginator",
      "projectBillingsSummary": "ProjectBillingsSummary",
      "projectCategories": "ProjectCategory",
      "projectDatesForBudgetChange": "ProjectDatesForBudgetChange",
      "projectForExpense": "ProjectForExpense",
      "projectForTask": "ProjectForTask",
      "projectGraph": "ProjectGraph",
      "projectHasTimeTrackedForPositions": "TimeTrackingWorkType",
      "projectLimited": "ProjectLimited",
      "projectManagerSimpleMap": "UserSimple",
      "projectRateCard": "ProjectRateCard",
      "projectRevenue": "ProjectRevenue",
      "projectRevenueDetail": "ProjectWithRevenue",
      "projectRevenueSummary": "ProjectRevenueSummary",
      "projectSettings": "ProjectSettings",
      "projectStages": "ProjectStage",
      "projectTimeBilling": "ProjectTimeBilling",
      "projectTimeBillings": "ProjectTimeBillingPaginator",
      "projectTimeBreakdowns": "ProjectTimeBreakdownResponse",
      "projects": "ProjectPaginator",
      "projectsAll": "ProjectSimplePaginator",
      "projectsForPlanovac": "ProjectForPlanovacPaginator",
      "projectsLimited": "ProjectLimitedPaginator",
      "projectsSimpleMap": "ProjectSimple",
      "projectsSummary": "ProjectsSummary",
      "projectsWithPeriods": "WorkInProgressProjectStatPaginator",
      "requestForInvoicing": "RequestForInvoicing",
      "requestsForInvoicing": "RequestForInvoicingPaginator",
      "requestsForInvoicingSummary": "RequestsForInvoicingSummary",
      "responsiblePersonsSimpleMap": "UserSimple",
      "roles": "Role",
      "runningTimer": "Timer",
      "sequenceSettings": "Sequence",
      "task": "Task",
      "taskAndCommunicationNotifications": "TaskAndCommunicationNotificationsPaginator",
      "taskBoardColumnCounts": "TaskBoardColumnCountPaginator",
      "taskBoardSettings": "TaskBoardSettings",
      "taskCommentFiles": "AssignableFile",
      "taskComments": "TaskCommentPaginator",
      "taskLinkTypes": "TaskLinkType",
      "taskPositionStat": "TaskPositionStat",
      "taskPriorities": "TaskPriority",
      "taskStatuses": "TaskStatus",
      "taskTemplateGroup": "TaskTemplateGroup",
      "taskTemplateGroups": "TaskTemplateGroup",
      "tasks": "TaskPaginator",
      "tasksSimpleMap": "TaskSimple",
      "teamSimpleMap": "Team",
      "timeMaterialsInvoiceData": "TimeMaterialsDataForInvoicing",
      "timeOffTypesQuery": "TimeOffType",
      "timeTrackingItem": "TimeTrackingItem",
      "timeTrackingItems": "TimeTrackingItem",
      "timeTrackingItemsPaginated": "TimeTrackingItemPaginator",
      "timeTrackingItemsWorkTypes": "TimeTrackingWorkType",
      "timeTrackingOptionsForProject": "TimeTrackingOptionsForProject",
      "timeTrackingProjectReport": "TimeTrackingProjectReport",
      "timeTrackingReport": "TimeTrackingReportPaginator",
      "timeTrackingReportSummary": "TimeTrackingReportSummary",
      "timeTrackingSummaryPerDay": "TimeTrackingSummaryPerDay",
      "timeTrackingWorkTypes": "TimeTrackingWorkType",
      "unusedPaidOutgoingProformaInvoices": "OutgoingProformaInvoice",
      "updateWorkspacePlanningSettings": "WorkspacePlanningSettings",
      "user": "User",
      "userMonthlyReport": "UserMonthlyReportPaginator",
      "userSimpleMap": "UserSimple",
      "users": "UserPaginator",
      "usersForPlanovac": "UserForPlanovac",
      "usersSummary": "UsersSummary",
      "utilizationReport": "UtilizationReportPaginator",
      "utilizationReportGroups": "UtilizationReportGroupPaginator",
      "utilizationReportSummary": "UtilizationReport",
      "utilizationTaskReport": "UtilizationTaskReport",
      "utilizationUserReport": "UtilizationUserReport",
      "vatRates": "VatRate",
      "verifyAccessTokenFromThirdParty": "SingleSignOnData",
      "weekTimeReport": "WeekTimeReport",
      "wipForBudgetAndPeriod": "WorkInProgressItemStat",
      "wipPeriodsMap": "WipPeriod",
      "wipProjectsPeriodSummary": "PeriodSummary",
      "workspaceAccountingAccountSetting": "WorkspaceAccountingAccountSettings",
      "workspaceAccountingCentreSetting": "WorkspaceAccountingCentreSettings",
      "workspaceAccountingVatClassificationSetting": "WorkspaceAccountingVatClassificationSettings",
      "workspaceAutoExpenseEmailSettings": "WorkspaceAutoExpenseEmailSettings",
      "workspaceCompaniesSettings": "WorkspaceCompanySetting",
      "workspaceExchangeRatesForBudgetovac": "CurrencyExchangeRate",
      "workspaceFinancialSettings": "WorkspaceFinancialSetting",
      "workspacePipedriveIntegration": "WorkspacePipedriveIntegration",
      "workspaceProjectSettings": "WorkspaceProjectSettings",
      "workspaceSettings": "WorkspaceSettings",
      "workspaceSmtpSettings": "WorkspaceSmtpSettings",
      "workspaceTaskSettings": "WorkspaceTaskSettings",
      "workspaceUserManagementSetting": "WorkspaceUserManagementSetting"
    },
    "Quote": {
      "Client": "Client",
      "budgets": "Budget",
      "client_approval_date": "Date",
      "createdBy": "User",
      "currency": "Currency",
      "sent_to_client_date": "Date",
      "settings": "BudgetPdfSettings"
    },
    "QuoteEmailData": {
      "attachments": "QuoteAttachment"
    },
    "QuotesPaginator": {
      "data": "Quote",
      "paginatorInfo": "PaginatorInfo"
    },
    "RequestForInvoicing": {
      "billingEntity": "BillingEntity",
      "brands": "Brand",
      "budget_positions": "BudgetPosition",
      "client": "Client",
      "contact": "Contact",
      "created_at": "DateTime",
      "currency": "Currency",
      "date_of_supply": "Date",
      "due_date": "Date",
      "expenseBudgetSplits": "RequestForInvoicingExpenseBudgetSplitItem",
      "filesToAttach": "AssignableFile",
      "invoiceItems": "OutgoingInvoiceItem",
      "invoicePaymentMethod": "InvoicePaymentMethod",
      "issue_date": "Date",
      "orders": "Order",
      "ourWorkBudgetSplits": "RequestForInvoicingOurWorkBudgetSplitItem",
      "owner": "User",
      "prepaymentSplits": "RequestForInvoicingPrepaymentSplitItem",
      "proformaInvoices": "OutgoingProformaInvoice",
      "projects": "Project",
      "proofOfPayments": "OutgoingInvoice",
      "stats": "RequestForInvoicingStats",
      "submit_date": "Date",
      "teams": "Team",
      "timeMaterialsInvoiceData": "TimeMaterialsInvoiceData",
      "updated_at": "DateTime"
    },
    "RequestForInvoicingExpenseBudgetSplitItem": {
      "created_at": "DateTime",
      "updated_at": "DateTime"
    },
    "RequestForInvoicingOurWorkBudgetSplitItem": {
      "created_at": "DateTime",
      "updated_at": "DateTime"
    },
    "RequestForInvoicingPaginator": {
      "data": "RequestForInvoicing",
      "paginatorInfo": "PaginatorInfo"
    },
    "RequestForInvoicingPrepaymentSplitItem": {
      "created_at": "DateTime",
      "updated_at": "DateTime"
    },
    "Role": {
      "documentLimits": "RoleDocumentLimit"
    },
    "Star": {
      "created_at": "DateTime",
      "updated_at": "DateTime",
      "user": "User"
    },
    "StructuredExpenseItemsItem": {
      "brand": "Brand",
      "expense_items": "ExpenseItem"
    },
    "SubmitProgressResult": {
      "changedWorkInProgressItemStats": "WorkInProgressItemStat",
      "lastWorkInProgressProjectStat": "WorkInProgressProjectStat"
    },
    "Tag": {
      "deleted_at": "DateTime"
    },
    "Task": {
      "commentFiles": "AssignableFile",
      "createdBy": "User",
      "created_at": "DateTime",
      "currentAssignee": "User",
      "deadline": "DateTime",
      "description": "TaskDescription",
      "files": "AssignableFile",
      "from": "Date",
      "linkedTasks": "TaskLink",
      "otherPeopleTracked": "OtherPeopleTracked",
      "ourWorkBudgetItem": "OurWorkBudgetItem",
      "parent": "Task",
      "positions": "TaskPosition",
      "positionsSpent": "PositionSpent",
      "priority": "TaskPriority",
      "scopes": "UserScope",
      "stats": "TaskStats",
      "status": "TaskStatus",
      "subtasks": "Task",
      "taskWatchers": "TaskWatcher",
      "teams": "Team",
      "timeTrackingItems": "TimeTrackingItem",
      "to": "Date",
      "updated_at": "DateTime",
      "users": "User"
    },
    "TaskAndCommunicationNotificationsPaginator": {
      "data": "NotificationPerTask",
      "paginatorInfo": "PaginatorInfo"
    },
    "TaskBoardColumnCountPaginator": {
      "data": "TaskBoardColumnCount",
      "paginatorInfo": "PaginatorInfo"
    },
    "TaskBoardSettings": {
      "sort": "TaskBoardSort"
    },
    "TaskBulkActionsData": {
      "available_positions": "TimeTrackingWorkType",
      "unavailable_positions": "TimeTrackingWorkType"
    },
    "TaskComment": {
      "created_at": "DateTime",
      "files": "AssignableFile",
      "in_reply_to": "TaskComment",
      "reactions": "TaskCommentReaction",
      "task": "Task",
      "timestamp": "DateTime",
      "user": "User"
    },
    "TaskCommentPaginator": {
      "data": "TaskComment",
      "paginatorInfo": "PaginatorInfo"
    },
    "TaskCommentReaction": {
      "user": "User"
    },
    "TaskLink": {
      "link_type": "TaskLinkType",
      "linked_task": "Task"
    },
    "TaskMoveUnmatchedData": {
      "target_available_work_types": "TimeTrackingWorkType",
      "unmatched_work_types": "TimeTrackingWorkType"
    },
    "TaskPaginator": {
      "data": "Task",
      "paginatorInfo": "PaginatorInfo"
    },
    "TaskPosition": {
      "timeTrackingWorkType": "TimeTrackingWorkType",
      "user": "User"
    },
    "TaskPositionStat": {
      "timeTrackingWorkType": "TimeTrackingWorkType",
      "user": "User"
    },
    "TaskSimple": {
      "created_at": "DateTime",
      "deadline": "DateTime",
      "from": "Date",
      "parent": "Task",
      "positions": "TaskPosition",
      "priority": "TaskPriority",
      "status": "TaskStatus",
      "subtasks": "Task",
      "to": "Date",
      "updated_at": "DateTime"
    },
    "TaskTemplateGroup": {
      "tasks": "Task"
    },
    "TaskWatcher": {
      "user": "User"
    },
    "Team": {
      "deleted_at": "DateTime"
    },
    "TeamAttendee": {
      "team": "Team"
    },
    "TimeMaterialsBudgetItems": {
      "data": "TimeMaterialsBudgetItemInvoiceData"
    },
    "TimeMaterialsDataForInvoicing": {
      "expenseBudgetItems": "TimeMaterialsBudgetItems",
      "ourWorkBudgetItems": "TimeMaterialsBudgetItems",
      "project": "Project"
    },
    "TimeMaterialsInvoiceData": {
      "commission_data": "TimeMaterialsCommissionData",
      "from": "Date",
      "to": "Date"
    },
    "TimeOffAssignee": {
      "user": "User"
    },
    "TimeTrackingBudgetItem": {
      "ourWorkBudgetItem": "OurWorkBudgetItem",
      "timeTrackingItems": "TimeTrackingItem",
      "tracking_enabled_from": "Date",
      "tracking_enabled_to": "Date"
    },
    "TimeTrackingBudgetItemForPlanovac": {
      "tracking_enabled_from": "Date",
      "tracking_enabled_to": "Date"
    },
    "TimeTrackingBudgetItemSimpleMap": {
      "available_time_tracking_work_types": "TimeTrackingWorkType"
    },
    "TimeTrackingItem": {
      "capacityAllocationItem": "CapacityAllocationItem",
      "created_at": "DateTime",
      "deleted_at": "DateTime",
      "lockedByUser": "User",
      "locked_at": "DateTime",
      "project": "Project",
      "specific_time_from": "Time",
      "specific_time_to": "Time",
      "task": "Task",
      "timeBilling": "ProjectTimeBilling",
      "timeBillingDistributions": "ProjectTimeBillingDistribution",
      "timeTrackingBudgetItem": "TimeTrackingBudgetItem",
      "timeTrackingWorkType": "TimeTrackingWorkType",
      "tracked_for_date": "Date",
      "updated_at": "DateTime",
      "user": "User"
    },
    "TimeTrackingItemPaginator": {
      "data": "TimeTrackingItem",
      "paginatorInfo": "PaginatorInfo"
    },
    "TimeTrackingOptionsForProject": {
      "availableTimeTrackingWorkTypes": "TimeTrackingWorkType",
      "ourWork": "OurWorkBudgetItemSimple"
    },
    "TimeTrackingRate": {
      "budget": "Budget",
      "timeTrackingWorkType": "TimeTrackingWorkType"
    },
    "TimeTrackingReport": {
      "locked_at": "DateTime",
      "tracked_for_date": "Date"
    },
    "TimeTrackingReportGroup": {
      "items": "TimeTrackingReport"
    },
    "TimeTrackingReportPaginator": {
      "data": "TimeTrackingReportGroup",
      "paginatorInfo": "PaginatorInfo"
    },
    "TimeTrackingSummaryPerDay": {
      "date": "Date"
    },
    "Timer": {
      "ends_at": "DateTime",
      "starts_at": "DateTime",
      "timeTrackingItem": "TimeTrackingItem"
    },
    "TopClient": {
      "brands": "TopBrand"
    },
    "TopProject": {
      "expense_budget_categories": "ExpenseBudgetCategoryTopProject",
      "our_work": "OurWorkTopProject"
    },
    "User": {
      "archived_at": "DateTime",
      "brands": "Brand",
      "created_at": "DateTime",
      "image": "AssignableFile",
      "mcpTokens": "McpToken",
      "permissions": "PermissionList",
      "profile": "UserProfile",
      "projects": "Project",
      "roles": "Role",
      "scope": "UserScope",
      "statusRanges": "UserStatusRange",
      "tasks": "Task",
      "team": "Team",
      "updated_at": "DateTime"
    },
    "UserAllocatedTime": {
      "dates": "UserAllocatedTimeDate"
    },
    "UserAllocatedTimeData": {
      "from_time": "Time",
      "to_time": "Time"
    },
    "UserAllocatedTimeDate": {
      "data": "UserAllocatedTimeData",
      "date": "Date"
    },
    "UserForPlanovac": {
      "archived_at": "DateTime",
      "created_at": "DateTime",
      "deleted_at": "DateTime",
      "image": "AssignableFile",
      "profile": "UserProfile",
      "updated_at": "DateTime"
    },
    "UserMonthlyReport": {
      "tracked_time_per_team": "UserMonthlyReportPerTeam"
    },
    "UserMonthlyReportPaginator": {
      "data": "UserMonthlyReport",
      "paginatorInfo": "PaginatorInfo",
      "teams": "Team"
    },
    "UserPaginator": {
      "data": "User",
      "paginatorInfo": "PaginatorInfo"
    },
    "UserProfile": {
      "defaultWorktype": "TimeTrackingWorkType",
      "planningRanges": "UserProfilePlanningRange",
      "rates": "UserProfileRate"
    },
    "UserProfilePlanningRange": {
      "type": "PlanningRangeType",
      "valid_from": "Date",
      "valid_to": "Date",
      "weekly_capacities": "WeeklyCapacities"
    },
    "UserProfileRate": {
      "valid_from": "Date",
      "valid_to": "Date"
    },
    "UserSimple": {
      "archived_at": "DateTime",
      "created_at": "DateTime",
      "deleted_at": "DateTime",
      "image": "AssignableFile",
      "profile": "UserProfile",
      "updated_at": "DateTime"
    },
    "UserStatusRange": {
      "projectManager": "User",
      "valid_from": "Date",
      "valid_to": "Date"
    },
    "UtilizationReportGroup": {
      "items": "UtilizationUserReport",
      "report": "UtilizationReport"
    },
    "UtilizationReportGroupPaginator": {
      "data": "UtilizationReportGroup",
      "paginatorInfo": "PaginatorInfo"
    },
    "UtilizationReportPaginator": {
      "data": "UtilizationUserReport",
      "paginatorInfo": "PaginatorInfo"
    },
    "UtilizationTaskReport": {
      "task": "Task"
    },
    "UtilizationUserReport": {
      "report": "UtilizationReport",
      "user": "User"
    },
    "WeekTimeReport": {
      "dailyTotals": "WeeklyTimeReportTotalsPerDay",
      "rows": "WeeklyTimeReportRow",
      "suggestions": "Task"
    },
    "WeeklyTimeReportRow": {
      "created_at": "DateTime",
      "task": "Task",
      "timeTrackingWorkType": "TimeTrackingWorkType",
      "trackedTime": "WeeklyTimeReportRowDay"
    },
    "WeeklyTimeReportRowDay": {
      "date": "Date"
    },
    "WeeklyTimeReportTotalsPerDay": {
      "date": "Date"
    },
    "WipPeriod": {
      "ends_at": "Date",
      "starts_at": "Date"
    },
    "WorkInProgressItemStat": {
      "period": "WipPeriod",
      "project": "Project"
    },
    "WorkInProgressProjectStat": {
      "budgetItemsStats": "WorkInProgressItemStat",
      "period": "WipPeriod",
      "project": "Project"
    },
    "WorkInProgressProjectStatPaginator": {
      "data": "WorkInProgressProjectStat",
      "paginatorInfo": "PaginatorInfo"
    },
    "WorkspaceAccountingAccount": {
      "budget_categories": "AccountingAccountBudgetCategory"
    },
    "WorkspaceAccountingAccountSettings": {
      "accounting_accounts": "WorkspaceAccountingAccount"
    },
    "WorkspaceAccountingCentreSettings": {
      "accounting_centres": "AccountingCentre"
    },
    "WorkspaceAccountingVatClassificationSettings": {
      "accounting_vat_classifications": "AccountingVatClassification"
    },
    "WorkspaceCompany": {
      "bankAccounts": "WorkspaceBankAccount",
      "country": "Country",
      "currency": "Currency",
      "invoicePdfSettings": "WorkspaceCompanyInvoicePdfSettings"
    },
    "WorkspaceCompanySetting": {
      "bank_accounts": "WorkspaceBankAccount",
      "pdfSettings": "WorkspaceInvoicePdfSettings",
      "sequences": "WorkspaceSequence"
    },
    "WorkspaceFinancialSetting": {
      "currencies": "Currency",
      "invoice_attachment_name_templates": "InvoiceAttachmentNameTemplates",
      "vat_rates": "VatRate"
    },
    "WorkspaceInvoicePdfSettings": {
      "logo_assignable_file": "AssignableFile",
      "stamp_assignable_file": "AssignableFile"
    },
    "WorkspacePipedriveIntegration": {
      "settings": "WorkspacePipedriveSettings"
    },
    "WorkspacePlanningSettings": {
      "working_from": "Time",
      "working_to": "Time"
    },
    "WorkspaceSettings": {
      "budget_pdf_export_settings": "BudgetPdfSettings",
      "companies": "WorkspaceCompany",
      "country": "Country",
      "currency": "Currency",
      "currencyExchangeRatesStructured": "CurrencyExchangeRateStructured",
      "defaultVatRate": "VatRate",
      "exportSettings": "ExportSettings",
      "invoice_attachment_name_templates": "InvoiceAttachmentNameTemplates",
      "moduleSettings": "ModuleSettings",
      "planning_view_settings": "PlanningViewSetting",
      "smtpSettings": "WorkspaceSmtpSettings",
      "trial_from": "Date",
      "working_from": "Time",
      "working_to": "Time"
    },
    "WorkspaceTaskSettings": {
      "task_priorities": "WorkspaceTaskPriority",
      "task_statuses": "WorkspaceTaskStatus"
    },
    "WorkspaceUserManagementSetting": {
      "teams": "Team"
    }
  },
  "operationMap": {},
  "scalars": [
    "Time",
    "Date",
    "DateTime"
  ]
};
